/*eslint-disable*/
import $protobuf from "protobufjs/minimal.js";

export const messages = /* #__PURE__ -- @preserve */ ( () => {
	var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.OperationMetadataDescriptor = (function() {

    function OperationMetadataDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    OperationMetadataDescriptor.prototype.userId = "";
    OperationMetadataDescriptor.prototype.type = "";
    OperationMetadataDescriptor.prototype.createdAt = "";

    OperationMetadataDescriptor.create = function create(properties) {
        return new OperationMetadataDescriptor(properties);
    };

    OperationMetadataDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(10).string(message.userId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(18).string(message.type);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(26).string(message.createdAt);
        return writer;
    };

    OperationMetadataDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    OperationMetadataDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OperationMetadataDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.userId = reader.string();
                    break;
                }
            case 2: {
                    message.type = reader.string();
                    break;
                }
            case 3: {
                    message.createdAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    OperationMetadataDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    OperationMetadataDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        return null;
    };

    OperationMetadataDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.OperationMetadataDescriptor)
            return object;
        var message = new $root.OperationMetadataDescriptor();
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.type != null)
            message.type = String(object.type);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        return message;
    };

    OperationMetadataDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.userId = "";
            object.type = "";
            object.createdAt = "";
        }
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        return object;
    };

    OperationMetadataDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    OperationMetadataDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/OperationMetadataDescriptor";
    };

    return OperationMetadataDescriptor;
})();

$root.CollaborativeEditingConnectMessage = (function() {

    function CollaborativeEditingConnectMessage(properties) {
        this.buffers = [];
        this.types = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CollaborativeEditingConnectMessage.prototype.id = "";
    CollaborativeEditingConnectMessage.prototype.bundleVersion = "";
    CollaborativeEditingConnectMessage.prototype.buffers = $util.emptyArray;
    CollaborativeEditingConnectMessage.prototype.types = $util.emptyArray;
    CollaborativeEditingConnectMessage.prototype.lastOperationId = "";

    CollaborativeEditingConnectMessage.create = function create(properties) {
        return new CollaborativeEditingConnectMessage(properties);
    };

    CollaborativeEditingConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.bundleVersion != null && Object.hasOwnProperty.call(message, "bundleVersion"))
            writer.uint32(18).string(message.bundleVersion);
        if (message.buffers != null && message.buffers.length)
            for (var i = 0; i < message.buffers.length; ++i)
                writer.uint32(26).bytes(message.buffers[i]);
        if (message.types != null && message.types.length) {
            writer.uint32(34).fork();
            for (var i = 0; i < message.types.length; ++i)
                writer.uint32(message.types[i]);
            writer.ldelim();
        }
        if (message.lastOperationId != null && Object.hasOwnProperty.call(message, "lastOperationId"))
            writer.uint32(42).string(message.lastOperationId);
        return writer;
    };

    CollaborativeEditingConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CollaborativeEditingConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CollaborativeEditingConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.bundleVersion = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.buffers && message.buffers.length))
                        message.buffers = [];
                    message.buffers.push(reader.bytes());
                    break;
                }
            case 4: {
                    if (!(message.types && message.types.length))
                        message.types = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.types.push(reader.uint32());
                    } else
                        message.types.push(reader.uint32());
                    break;
                }
            case 5: {
                    message.lastOperationId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CollaborativeEditingConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CollaborativeEditingConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            if (!$util.isString(message.bundleVersion))
                return "bundleVersion: string expected";
        if (message.buffers != null && message.hasOwnProperty("buffers")) {
            if (!Array.isArray(message.buffers))
                return "buffers: array expected";
            for (var i = 0; i < message.buffers.length; ++i)
                if (!(message.buffers[i] && typeof message.buffers[i].length === "number" || $util.isString(message.buffers[i])))
                    return "buffers: buffer[] expected";
        }
        if (message.types != null && message.hasOwnProperty("types")) {
            if (!Array.isArray(message.types))
                return "types: array expected";
            for (var i = 0; i < message.types.length; ++i)
                if (!$util.isInteger(message.types[i]))
                    return "types: integer[] expected";
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            if (!$util.isString(message.lastOperationId))
                return "lastOperationId: string expected";
        return null;
    };

    CollaborativeEditingConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CollaborativeEditingConnectMessage)
            return object;
        var message = new $root.CollaborativeEditingConnectMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.bundleVersion != null)
            message.bundleVersion = String(object.bundleVersion);
        if (object.buffers) {
            if (!Array.isArray(object.buffers))
                throw TypeError(".CollaborativeEditingConnectMessage.buffers: array expected");
            message.buffers = [];
            for (var i = 0; i < object.buffers.length; ++i)
                if (typeof object.buffers[i] === "string")
                    $util.base64.decode(object.buffers[i], message.buffers[i] = $util.newBuffer($util.base64.length(object.buffers[i])), 0);
                else if (object.buffers[i].length >= 0)
                    message.buffers[i] = object.buffers[i];
        }
        if (object.types) {
            if (!Array.isArray(object.types))
                throw TypeError(".CollaborativeEditingConnectMessage.types: array expected");
            message.types = [];
            for (var i = 0; i < object.types.length; ++i)
                message.types[i] = object.types[i] >>> 0;
        }
        if (object.lastOperationId != null)
            message.lastOperationId = String(object.lastOperationId);
        return message;
    };

    CollaborativeEditingConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.buffers = [];
            object.types = [];
        }
        if (options.defaults) {
            object.id = "";
            object.bundleVersion = "";
            object.lastOperationId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            object.bundleVersion = message.bundleVersion;
        if (message.buffers && message.buffers.length) {
            object.buffers = [];
            for (var j = 0; j < message.buffers.length; ++j)
                object.buffers[j] = options.bytes === String ? $util.base64.encode(message.buffers[j], 0, message.buffers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.buffers[j]) : message.buffers[j];
        }
        if (message.types && message.types.length) {
            object.types = [];
            for (var j = 0; j < message.types.length; ++j)
                object.types[j] = message.types[j];
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            object.lastOperationId = message.lastOperationId;
        return object;
    };

    CollaborativeEditingConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CollaborativeEditingConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CollaborativeEditingConnectMessage";
    };

    return CollaborativeEditingConnectMessage;
})();

$root.CollaborativeEditingReconnectMessage = (function() {

    function CollaborativeEditingReconnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CollaborativeEditingReconnectMessage.prototype.id = "";
    CollaborativeEditingReconnectMessage.prototype.bundleVersion = "";
    CollaborativeEditingReconnectMessage.prototype.lastKnowVersion = 0;

    CollaborativeEditingReconnectMessage.create = function create(properties) {
        return new CollaborativeEditingReconnectMessage(properties);
    };

    CollaborativeEditingReconnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.bundleVersion != null && Object.hasOwnProperty.call(message, "bundleVersion"))
            writer.uint32(18).string(message.bundleVersion);
        if (message.lastKnowVersion != null && Object.hasOwnProperty.call(message, "lastKnowVersion"))
            writer.uint32(24).uint32(message.lastKnowVersion);
        return writer;
    };

    CollaborativeEditingReconnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CollaborativeEditingReconnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CollaborativeEditingReconnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.bundleVersion = reader.string();
                    break;
                }
            case 3: {
                    message.lastKnowVersion = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CollaborativeEditingReconnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CollaborativeEditingReconnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            if (!$util.isString(message.bundleVersion))
                return "bundleVersion: string expected";
        if (message.lastKnowVersion != null && message.hasOwnProperty("lastKnowVersion"))
            if (!$util.isInteger(message.lastKnowVersion))
                return "lastKnowVersion: integer expected";
        return null;
    };

    CollaborativeEditingReconnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CollaborativeEditingReconnectMessage)
            return object;
        var message = new $root.CollaborativeEditingReconnectMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.bundleVersion != null)
            message.bundleVersion = String(object.bundleVersion);
        if (object.lastKnowVersion != null)
            message.lastKnowVersion = object.lastKnowVersion >>> 0;
        return message;
    };

    CollaborativeEditingReconnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.bundleVersion = "";
            object.lastKnowVersion = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            object.bundleVersion = message.bundleVersion;
        if (message.lastKnowVersion != null && message.hasOwnProperty("lastKnowVersion"))
            object.lastKnowVersion = message.lastKnowVersion;
        return object;
    };

    CollaborativeEditingReconnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CollaborativeEditingReconnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CollaborativeEditingReconnectMessage";
    };

    return CollaborativeEditingReconnectMessage;
})();

$root.CollaborativeEditingUpdateMessage = (function() {

    function CollaborativeEditingUpdateMessage(properties) {
        this.buffers = [];
        this.types = [];
        this.metadata = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CollaborativeEditingUpdateMessage.prototype.id = "";
    CollaborativeEditingUpdateMessage.prototype.baseVersion = 0;
    CollaborativeEditingUpdateMessage.prototype.buffers = $util.emptyArray;
    CollaborativeEditingUpdateMessage.prototype.types = $util.emptyArray;
    CollaborativeEditingUpdateMessage.prototype.metadata = $util.emptyArray;
    CollaborativeEditingUpdateMessage.prototype.lastOperationId = "";

    CollaborativeEditingUpdateMessage.create = function create(properties) {
        return new CollaborativeEditingUpdateMessage(properties);
    };

    CollaborativeEditingUpdateMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.baseVersion != null && Object.hasOwnProperty.call(message, "baseVersion"))
            writer.uint32(16).uint32(message.baseVersion);
        if (message.buffers != null && message.buffers.length)
            for (var i = 0; i < message.buffers.length; ++i)
                writer.uint32(26).bytes(message.buffers[i]);
        if (message.types != null && message.types.length) {
            writer.uint32(34).fork();
            for (var i = 0; i < message.types.length; ++i)
                writer.uint32(message.types[i]);
            writer.ldelim();
        }
        if (message.metadata != null && message.metadata.length)
            for (var i = 0; i < message.metadata.length; ++i)
                $root.OperationMetadataDescriptor.encode(message.metadata[i], writer.uint32(50).fork()).ldelim();
        if (message.lastOperationId != null && Object.hasOwnProperty.call(message, "lastOperationId"))
            writer.uint32(58).string(message.lastOperationId);
        return writer;
    };

    CollaborativeEditingUpdateMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CollaborativeEditingUpdateMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CollaborativeEditingUpdateMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.baseVersion = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.buffers && message.buffers.length))
                        message.buffers = [];
                    message.buffers.push(reader.bytes());
                    break;
                }
            case 4: {
                    if (!(message.types && message.types.length))
                        message.types = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.types.push(reader.uint32());
                    } else
                        message.types.push(reader.uint32());
                    break;
                }
            case 6: {
                    if (!(message.metadata && message.metadata.length))
                        message.metadata = [];
                    message.metadata.push($root.OperationMetadataDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            case 7: {
                    message.lastOperationId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CollaborativeEditingUpdateMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CollaborativeEditingUpdateMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.baseVersion != null && message.hasOwnProperty("baseVersion"))
            if (!$util.isInteger(message.baseVersion))
                return "baseVersion: integer expected";
        if (message.buffers != null && message.hasOwnProperty("buffers")) {
            if (!Array.isArray(message.buffers))
                return "buffers: array expected";
            for (var i = 0; i < message.buffers.length; ++i)
                if (!(message.buffers[i] && typeof message.buffers[i].length === "number" || $util.isString(message.buffers[i])))
                    return "buffers: buffer[] expected";
        }
        if (message.types != null && message.hasOwnProperty("types")) {
            if (!Array.isArray(message.types))
                return "types: array expected";
            for (var i = 0; i < message.types.length; ++i)
                if (!$util.isInteger(message.types[i]))
                    return "types: integer[] expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            if (!Array.isArray(message.metadata))
                return "metadata: array expected";
            for (var i = 0; i < message.metadata.length; ++i) {
                var error = $root.OperationMetadataDescriptor.verify(message.metadata[i]);
                if (error)
                    return "metadata." + error;
            }
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            if (!$util.isString(message.lastOperationId))
                return "lastOperationId: string expected";
        return null;
    };

    CollaborativeEditingUpdateMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CollaborativeEditingUpdateMessage)
            return object;
        var message = new $root.CollaborativeEditingUpdateMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.baseVersion != null)
            message.baseVersion = object.baseVersion >>> 0;
        if (object.buffers) {
            if (!Array.isArray(object.buffers))
                throw TypeError(".CollaborativeEditingUpdateMessage.buffers: array expected");
            message.buffers = [];
            for (var i = 0; i < object.buffers.length; ++i)
                if (typeof object.buffers[i] === "string")
                    $util.base64.decode(object.buffers[i], message.buffers[i] = $util.newBuffer($util.base64.length(object.buffers[i])), 0);
                else if (object.buffers[i].length >= 0)
                    message.buffers[i] = object.buffers[i];
        }
        if (object.types) {
            if (!Array.isArray(object.types))
                throw TypeError(".CollaborativeEditingUpdateMessage.types: array expected");
            message.types = [];
            for (var i = 0; i < object.types.length; ++i)
                message.types[i] = object.types[i] >>> 0;
        }
        if (object.metadata) {
            if (!Array.isArray(object.metadata))
                throw TypeError(".CollaborativeEditingUpdateMessage.metadata: array expected");
            message.metadata = [];
            for (var i = 0; i < object.metadata.length; ++i) {
                if (typeof object.metadata[i] !== "object")
                    throw TypeError(".CollaborativeEditingUpdateMessage.metadata: object expected");
                message.metadata[i] = $root.OperationMetadataDescriptor.fromObject(object.metadata[i]);
            }
        }
        if (object.lastOperationId != null)
            message.lastOperationId = String(object.lastOperationId);
        return message;
    };

    CollaborativeEditingUpdateMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.buffers = [];
            object.types = [];
            object.metadata = [];
        }
        if (options.defaults) {
            object.id = "";
            object.baseVersion = 0;
            object.lastOperationId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.baseVersion != null && message.hasOwnProperty("baseVersion"))
            object.baseVersion = message.baseVersion;
        if (message.buffers && message.buffers.length) {
            object.buffers = [];
            for (var j = 0; j < message.buffers.length; ++j)
                object.buffers[j] = options.bytes === String ? $util.base64.encode(message.buffers[j], 0, message.buffers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.buffers[j]) : message.buffers[j];
        }
        if (message.types && message.types.length) {
            object.types = [];
            for (var j = 0; j < message.types.length; ++j)
                object.types[j] = message.types[j];
        }
        if (message.metadata && message.metadata.length) {
            object.metadata = [];
            for (var j = 0; j < message.metadata.length; ++j)
                object.metadata[j] = $root.OperationMetadataDescriptor.toObject(message.metadata[j], options);
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            object.lastOperationId = message.lastOperationId;
        return object;
    };

    CollaborativeEditingUpdateMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CollaborativeEditingUpdateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CollaborativeEditingUpdateMessage";
    };

    return CollaborativeEditingUpdateMessage;
})();

$root.GetDocumentDetailsMessage = (function() {

    function GetDocumentDetailsMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetDocumentDetailsMessage.prototype.documentId = "";
    GetDocumentDetailsMessage.prototype.environmentId = "";

    GetDocumentDetailsMessage.create = function create(properties) {
        return new GetDocumentDetailsMessage(properties);
    };

    GetDocumentDetailsMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        if (message.environmentId != null && Object.hasOwnProperty.call(message, "environmentId"))
            writer.uint32(18).string(message.environmentId);
        return writer;
    };

    GetDocumentDetailsMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetDocumentDetailsMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetDocumentDetailsMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            case 2: {
                    message.environmentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetDocumentDetailsMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetDocumentDetailsMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.environmentId != null && message.hasOwnProperty("environmentId"))
            if (!$util.isString(message.environmentId))
                return "environmentId: string expected";
        return null;
    };

    GetDocumentDetailsMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.GetDocumentDetailsMessage)
            return object;
        var message = new $root.GetDocumentDetailsMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.environmentId != null)
            message.environmentId = String(object.environmentId);
        return message;
    };

    GetDocumentDetailsMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.documentId = "";
            object.environmentId = "";
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.environmentId != null && message.hasOwnProperty("environmentId"))
            object.environmentId = message.environmentId;
        return object;
    };

    GetDocumentDetailsMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetDocumentDetailsMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetDocumentDetailsMessage";
    };

    return GetDocumentDetailsMessage;
})();

$root.CollaborativeEditingConnectResponse = (function() {

    function CollaborativeEditingConnectResponse(properties) {
        this.buffers = [];
        this.types = [];
        this.metadata = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CollaborativeEditingConnectResponse.prototype.channel = "";
    CollaborativeEditingConnectResponse.prototype.offset = 0;
    CollaborativeEditingConnectResponse.prototype.version = 0;
    CollaborativeEditingConnectResponse.prototype.buffers = $util.emptyArray;
    CollaborativeEditingConnectResponse.prototype.types = $util.emptyArray;
    CollaborativeEditingConnectResponse.prototype.metadata = $util.emptyArray;
    CollaborativeEditingConnectResponse.prototype.initData = "";
    CollaborativeEditingConnectResponse.prototype.isInitialized = false;
    CollaborativeEditingConnectResponse.prototype.sessionId = "";
    CollaborativeEditingConnectResponse.prototype.lastOperationId = "";
    CollaborativeEditingConnectResponse.prototype.sessionCreatedAt = "";

    CollaborativeEditingConnectResponse.create = function create(properties) {
        return new CollaborativeEditingConnectResponse(properties);
    };

    CollaborativeEditingConnectResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(10).string(message.channel);
        if (message.offset != null && Object.hasOwnProperty.call(message, "offset"))
            writer.uint32(16).uint32(message.offset);
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(24).uint32(message.version);
        if (message.buffers != null && message.buffers.length)
            for (var i = 0; i < message.buffers.length; ++i)
                writer.uint32(34).bytes(message.buffers[i]);
        if (message.types != null && message.types.length) {
            writer.uint32(42).fork();
            for (var i = 0; i < message.types.length; ++i)
                writer.uint32(message.types[i]);
            writer.ldelim();
        }
        if (message.metadata != null && message.metadata.length)
            for (var i = 0; i < message.metadata.length; ++i)
                $root.OperationMetadataDescriptor.encode(message.metadata[i], writer.uint32(58).fork()).ldelim();
        if (message.initData != null && Object.hasOwnProperty.call(message, "initData"))
            writer.uint32(66).string(message.initData);
        if (message.isInitialized != null && Object.hasOwnProperty.call(message, "isInitialized"))
            writer.uint32(72).bool(message.isInitialized);
        if (message.sessionId != null && Object.hasOwnProperty.call(message, "sessionId"))
            writer.uint32(82).string(message.sessionId);
        if (message.lastOperationId != null && Object.hasOwnProperty.call(message, "lastOperationId"))
            writer.uint32(90).string(message.lastOperationId);
        if (message.sessionCreatedAt != null && Object.hasOwnProperty.call(message, "sessionCreatedAt"))
            writer.uint32(98).string(message.sessionCreatedAt);
        return writer;
    };

    CollaborativeEditingConnectResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CollaborativeEditingConnectResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CollaborativeEditingConnectResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.string();
                    break;
                }
            case 2: {
                    message.offset = reader.uint32();
                    break;
                }
            case 3: {
                    message.version = reader.uint32();
                    break;
                }
            case 4: {
                    if (!(message.buffers && message.buffers.length))
                        message.buffers = [];
                    message.buffers.push(reader.bytes());
                    break;
                }
            case 5: {
                    if (!(message.types && message.types.length))
                        message.types = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.types.push(reader.uint32());
                    } else
                        message.types.push(reader.uint32());
                    break;
                }
            case 7: {
                    if (!(message.metadata && message.metadata.length))
                        message.metadata = [];
                    message.metadata.push($root.OperationMetadataDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            case 8: {
                    message.initData = reader.string();
                    break;
                }
            case 9: {
                    message.isInitialized = reader.bool();
                    break;
                }
            case 10: {
                    message.sessionId = reader.string();
                    break;
                }
            case 11: {
                    message.lastOperationId = reader.string();
                    break;
                }
            case 12: {
                    message.sessionCreatedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CollaborativeEditingConnectResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CollaborativeEditingConnectResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.offset != null && message.hasOwnProperty("offset"))
            if (!$util.isInteger(message.offset))
                return "offset: integer expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.buffers != null && message.hasOwnProperty("buffers")) {
            if (!Array.isArray(message.buffers))
                return "buffers: array expected";
            for (var i = 0; i < message.buffers.length; ++i)
                if (!(message.buffers[i] && typeof message.buffers[i].length === "number" || $util.isString(message.buffers[i])))
                    return "buffers: buffer[] expected";
        }
        if (message.types != null && message.hasOwnProperty("types")) {
            if (!Array.isArray(message.types))
                return "types: array expected";
            for (var i = 0; i < message.types.length; ++i)
                if (!$util.isInteger(message.types[i]))
                    return "types: integer[] expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            if (!Array.isArray(message.metadata))
                return "metadata: array expected";
            for (var i = 0; i < message.metadata.length; ++i) {
                var error = $root.OperationMetadataDescriptor.verify(message.metadata[i]);
                if (error)
                    return "metadata." + error;
            }
        }
        if (message.initData != null && message.hasOwnProperty("initData"))
            if (!$util.isString(message.initData))
                return "initData: string expected";
        if (message.isInitialized != null && message.hasOwnProperty("isInitialized"))
            if (typeof message.isInitialized !== "boolean")
                return "isInitialized: boolean expected";
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            if (!$util.isString(message.sessionId))
                return "sessionId: string expected";
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            if (!$util.isString(message.lastOperationId))
                return "lastOperationId: string expected";
        if (message.sessionCreatedAt != null && message.hasOwnProperty("sessionCreatedAt"))
            if (!$util.isString(message.sessionCreatedAt))
                return "sessionCreatedAt: string expected";
        return null;
    };

    CollaborativeEditingConnectResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CollaborativeEditingConnectResponse)
            return object;
        var message = new $root.CollaborativeEditingConnectResponse();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.offset != null)
            message.offset = object.offset >>> 0;
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.buffers) {
            if (!Array.isArray(object.buffers))
                throw TypeError(".CollaborativeEditingConnectResponse.buffers: array expected");
            message.buffers = [];
            for (var i = 0; i < object.buffers.length; ++i)
                if (typeof object.buffers[i] === "string")
                    $util.base64.decode(object.buffers[i], message.buffers[i] = $util.newBuffer($util.base64.length(object.buffers[i])), 0);
                else if (object.buffers[i].length >= 0)
                    message.buffers[i] = object.buffers[i];
        }
        if (object.types) {
            if (!Array.isArray(object.types))
                throw TypeError(".CollaborativeEditingConnectResponse.types: array expected");
            message.types = [];
            for (var i = 0; i < object.types.length; ++i)
                message.types[i] = object.types[i] >>> 0;
        }
        if (object.metadata) {
            if (!Array.isArray(object.metadata))
                throw TypeError(".CollaborativeEditingConnectResponse.metadata: array expected");
            message.metadata = [];
            for (var i = 0; i < object.metadata.length; ++i) {
                if (typeof object.metadata[i] !== "object")
                    throw TypeError(".CollaborativeEditingConnectResponse.metadata: object expected");
                message.metadata[i] = $root.OperationMetadataDescriptor.fromObject(object.metadata[i]);
            }
        }
        if (object.initData != null)
            message.initData = String(object.initData);
        if (object.isInitialized != null)
            message.isInitialized = Boolean(object.isInitialized);
        if (object.sessionId != null)
            message.sessionId = String(object.sessionId);
        if (object.lastOperationId != null)
            message.lastOperationId = String(object.lastOperationId);
        if (object.sessionCreatedAt != null)
            message.sessionCreatedAt = String(object.sessionCreatedAt);
        return message;
    };

    CollaborativeEditingConnectResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.buffers = [];
            object.types = [];
            object.metadata = [];
        }
        if (options.defaults) {
            object.channel = "";
            object.offset = 0;
            object.version = 0;
            object.initData = "";
            object.isInitialized = false;
            object.sessionId = "";
            object.lastOperationId = "";
            object.sessionCreatedAt = "";
        }
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.offset != null && message.hasOwnProperty("offset"))
            object.offset = message.offset;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.buffers && message.buffers.length) {
            object.buffers = [];
            for (var j = 0; j < message.buffers.length; ++j)
                object.buffers[j] = options.bytes === String ? $util.base64.encode(message.buffers[j], 0, message.buffers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.buffers[j]) : message.buffers[j];
        }
        if (message.types && message.types.length) {
            object.types = [];
            for (var j = 0; j < message.types.length; ++j)
                object.types[j] = message.types[j];
        }
        if (message.metadata && message.metadata.length) {
            object.metadata = [];
            for (var j = 0; j < message.metadata.length; ++j)
                object.metadata[j] = $root.OperationMetadataDescriptor.toObject(message.metadata[j], options);
        }
        if (message.initData != null && message.hasOwnProperty("initData"))
            object.initData = message.initData;
        if (message.isInitialized != null && message.hasOwnProperty("isInitialized"))
            object.isInitialized = message.isInitialized;
        if (message.sessionId != null && message.hasOwnProperty("sessionId"))
            object.sessionId = message.sessionId;
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            object.lastOperationId = message.lastOperationId;
        if (message.sessionCreatedAt != null && message.hasOwnProperty("sessionCreatedAt"))
            object.sessionCreatedAt = message.sessionCreatedAt;
        return object;
    };

    CollaborativeEditingConnectResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CollaborativeEditingConnectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CollaborativeEditingConnectResponse";
    };

    return CollaborativeEditingConnectResponse;
})();

$root.CollaborativeEditingResponse = (function() {

    function CollaborativeEditingResponse(properties) {
        this.buffers = [];
        this.types = [];
        this.metadata = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CollaborativeEditingResponse.prototype.version = 0;
    CollaborativeEditingResponse.prototype.buffers = $util.emptyArray;
    CollaborativeEditingResponse.prototype.types = $util.emptyArray;
    CollaborativeEditingResponse.prototype.metadata = $util.emptyArray;
    CollaborativeEditingResponse.prototype.lastOperationId = "";
    CollaborativeEditingResponse.prototype.lastOperationAcceptedAt = "";

    CollaborativeEditingResponse.create = function create(properties) {
        return new CollaborativeEditingResponse(properties);
    };

    CollaborativeEditingResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
            writer.uint32(8).uint32(message.version);
        if (message.buffers != null && message.buffers.length)
            for (var i = 0; i < message.buffers.length; ++i)
                writer.uint32(18).bytes(message.buffers[i]);
        if (message.types != null && message.types.length) {
            writer.uint32(26).fork();
            for (var i = 0; i < message.types.length; ++i)
                writer.uint32(message.types[i]);
            writer.ldelim();
        }
        if (message.metadata != null && message.metadata.length)
            for (var i = 0; i < message.metadata.length; ++i)
                $root.OperationMetadataDescriptor.encode(message.metadata[i], writer.uint32(42).fork()).ldelim();
        if (message.lastOperationId != null && Object.hasOwnProperty.call(message, "lastOperationId"))
            writer.uint32(50).string(message.lastOperationId);
        if (message.lastOperationAcceptedAt != null && Object.hasOwnProperty.call(message, "lastOperationAcceptedAt"))
            writer.uint32(58).string(message.lastOperationAcceptedAt);
        return writer;
    };

    CollaborativeEditingResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CollaborativeEditingResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CollaborativeEditingResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.version = reader.uint32();
                    break;
                }
            case 2: {
                    if (!(message.buffers && message.buffers.length))
                        message.buffers = [];
                    message.buffers.push(reader.bytes());
                    break;
                }
            case 3: {
                    if (!(message.types && message.types.length))
                        message.types = [];
                    if ((tag & 7) === 2) {
                        var end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2)
                            message.types.push(reader.uint32());
                    } else
                        message.types.push(reader.uint32());
                    break;
                }
            case 5: {
                    if (!(message.metadata && message.metadata.length))
                        message.metadata = [];
                    message.metadata.push($root.OperationMetadataDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            case 6: {
                    message.lastOperationId = reader.string();
                    break;
                }
            case 7: {
                    message.lastOperationAcceptedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CollaborativeEditingResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CollaborativeEditingResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.buffers != null && message.hasOwnProperty("buffers")) {
            if (!Array.isArray(message.buffers))
                return "buffers: array expected";
            for (var i = 0; i < message.buffers.length; ++i)
                if (!(message.buffers[i] && typeof message.buffers[i].length === "number" || $util.isString(message.buffers[i])))
                    return "buffers: buffer[] expected";
        }
        if (message.types != null && message.hasOwnProperty("types")) {
            if (!Array.isArray(message.types))
                return "types: array expected";
            for (var i = 0; i < message.types.length; ++i)
                if (!$util.isInteger(message.types[i]))
                    return "types: integer[] expected";
        }
        if (message.metadata != null && message.hasOwnProperty("metadata")) {
            if (!Array.isArray(message.metadata))
                return "metadata: array expected";
            for (var i = 0; i < message.metadata.length; ++i) {
                var error = $root.OperationMetadataDescriptor.verify(message.metadata[i]);
                if (error)
                    return "metadata." + error;
            }
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            if (!$util.isString(message.lastOperationId))
                return "lastOperationId: string expected";
        if (message.lastOperationAcceptedAt != null && message.hasOwnProperty("lastOperationAcceptedAt"))
            if (!$util.isString(message.lastOperationAcceptedAt))
                return "lastOperationAcceptedAt: string expected";
        return null;
    };

    CollaborativeEditingResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CollaborativeEditingResponse)
            return object;
        var message = new $root.CollaborativeEditingResponse();
        if (object.version != null)
            message.version = object.version >>> 0;
        if (object.buffers) {
            if (!Array.isArray(object.buffers))
                throw TypeError(".CollaborativeEditingResponse.buffers: array expected");
            message.buffers = [];
            for (var i = 0; i < object.buffers.length; ++i)
                if (typeof object.buffers[i] === "string")
                    $util.base64.decode(object.buffers[i], message.buffers[i] = $util.newBuffer($util.base64.length(object.buffers[i])), 0);
                else if (object.buffers[i].length >= 0)
                    message.buffers[i] = object.buffers[i];
        }
        if (object.types) {
            if (!Array.isArray(object.types))
                throw TypeError(".CollaborativeEditingResponse.types: array expected");
            message.types = [];
            for (var i = 0; i < object.types.length; ++i)
                message.types[i] = object.types[i] >>> 0;
        }
        if (object.metadata) {
            if (!Array.isArray(object.metadata))
                throw TypeError(".CollaborativeEditingResponse.metadata: array expected");
            message.metadata = [];
            for (var i = 0; i < object.metadata.length; ++i) {
                if (typeof object.metadata[i] !== "object")
                    throw TypeError(".CollaborativeEditingResponse.metadata: object expected");
                message.metadata[i] = $root.OperationMetadataDescriptor.fromObject(object.metadata[i]);
            }
        }
        if (object.lastOperationId != null)
            message.lastOperationId = String(object.lastOperationId);
        if (object.lastOperationAcceptedAt != null)
            message.lastOperationAcceptedAt = String(object.lastOperationAcceptedAt);
        return message;
    };

    CollaborativeEditingResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.buffers = [];
            object.types = [];
            object.metadata = [];
        }
        if (options.defaults) {
            object.version = 0;
            object.lastOperationId = "";
            object.lastOperationAcceptedAt = "";
        }
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.buffers && message.buffers.length) {
            object.buffers = [];
            for (var j = 0; j < message.buffers.length; ++j)
                object.buffers[j] = options.bytes === String ? $util.base64.encode(message.buffers[j], 0, message.buffers[j].length) : options.bytes === Array ? Array.prototype.slice.call(message.buffers[j]) : message.buffers[j];
        }
        if (message.types && message.types.length) {
            object.types = [];
            for (var j = 0; j < message.types.length; ++j)
                object.types[j] = message.types[j];
        }
        if (message.metadata && message.metadata.length) {
            object.metadata = [];
            for (var j = 0; j < message.metadata.length; ++j)
                object.metadata[j] = $root.OperationMetadataDescriptor.toObject(message.metadata[j], options);
        }
        if (message.lastOperationId != null && message.hasOwnProperty("lastOperationId"))
            object.lastOperationId = message.lastOperationId;
        if (message.lastOperationAcceptedAt != null && message.hasOwnProperty("lastOperationAcceptedAt"))
            object.lastOperationAcceptedAt = message.lastOperationAcceptedAt;
        return object;
    };

    CollaborativeEditingResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CollaborativeEditingResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CollaborativeEditingResponse";
    };

    return CollaborativeEditingResponse;
})();

$root.GetDocumentDetailsResponse = (function() {

    function GetDocumentDetailsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetDocumentDetailsResponse.prototype.lastDocumentSessionId = "";
    GetDocumentDetailsResponse.prototype.lastDocumentSessionOperationId = "";
    GetDocumentDetailsResponse.prototype.currentDocumentSessionId = "";
    GetDocumentDetailsResponse.prototype.currentDocumentSessionVersion = 0;
    GetDocumentDetailsResponse.prototype.currentDocumentSessionOperationId = "";

    GetDocumentDetailsResponse.create = function create(properties) {
        return new GetDocumentDetailsResponse(properties);
    };

    GetDocumentDetailsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.lastDocumentSessionId != null && Object.hasOwnProperty.call(message, "lastDocumentSessionId"))
            writer.uint32(10).string(message.lastDocumentSessionId);
        if (message.lastDocumentSessionOperationId != null && Object.hasOwnProperty.call(message, "lastDocumentSessionOperationId"))
            writer.uint32(18).string(message.lastDocumentSessionOperationId);
        if (message.currentDocumentSessionId != null && Object.hasOwnProperty.call(message, "currentDocumentSessionId"))
            writer.uint32(26).string(message.currentDocumentSessionId);
        if (message.currentDocumentSessionVersion != null && Object.hasOwnProperty.call(message, "currentDocumentSessionVersion"))
            writer.uint32(32).uint32(message.currentDocumentSessionVersion);
        if (message.currentDocumentSessionOperationId != null && Object.hasOwnProperty.call(message, "currentDocumentSessionOperationId"))
            writer.uint32(42).string(message.currentDocumentSessionOperationId);
        return writer;
    };

    GetDocumentDetailsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetDocumentDetailsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetDocumentDetailsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.lastDocumentSessionId = reader.string();
                    break;
                }
            case 2: {
                    message.lastDocumentSessionOperationId = reader.string();
                    break;
                }
            case 3: {
                    message.currentDocumentSessionId = reader.string();
                    break;
                }
            case 4: {
                    message.currentDocumentSessionVersion = reader.uint32();
                    break;
                }
            case 5: {
                    message.currentDocumentSessionOperationId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetDocumentDetailsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetDocumentDetailsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.lastDocumentSessionId != null && message.hasOwnProperty("lastDocumentSessionId"))
            if (!$util.isString(message.lastDocumentSessionId))
                return "lastDocumentSessionId: string expected";
        if (message.lastDocumentSessionOperationId != null && message.hasOwnProperty("lastDocumentSessionOperationId"))
            if (!$util.isString(message.lastDocumentSessionOperationId))
                return "lastDocumentSessionOperationId: string expected";
        if (message.currentDocumentSessionId != null && message.hasOwnProperty("currentDocumentSessionId"))
            if (!$util.isString(message.currentDocumentSessionId))
                return "currentDocumentSessionId: string expected";
        if (message.currentDocumentSessionVersion != null && message.hasOwnProperty("currentDocumentSessionVersion"))
            if (!$util.isInteger(message.currentDocumentSessionVersion))
                return "currentDocumentSessionVersion: integer expected";
        if (message.currentDocumentSessionOperationId != null && message.hasOwnProperty("currentDocumentSessionOperationId"))
            if (!$util.isString(message.currentDocumentSessionOperationId))
                return "currentDocumentSessionOperationId: string expected";
        return null;
    };

    GetDocumentDetailsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetDocumentDetailsResponse)
            return object;
        var message = new $root.GetDocumentDetailsResponse();
        if (object.lastDocumentSessionId != null)
            message.lastDocumentSessionId = String(object.lastDocumentSessionId);
        if (object.lastDocumentSessionOperationId != null)
            message.lastDocumentSessionOperationId = String(object.lastDocumentSessionOperationId);
        if (object.currentDocumentSessionId != null)
            message.currentDocumentSessionId = String(object.currentDocumentSessionId);
        if (object.currentDocumentSessionVersion != null)
            message.currentDocumentSessionVersion = object.currentDocumentSessionVersion >>> 0;
        if (object.currentDocumentSessionOperationId != null)
            message.currentDocumentSessionOperationId = String(object.currentDocumentSessionOperationId);
        return message;
    };

    GetDocumentDetailsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.lastDocumentSessionId = "";
            object.lastDocumentSessionOperationId = "";
            object.currentDocumentSessionId = "";
            object.currentDocumentSessionVersion = 0;
            object.currentDocumentSessionOperationId = "";
        }
        if (message.lastDocumentSessionId != null && message.hasOwnProperty("lastDocumentSessionId"))
            object.lastDocumentSessionId = message.lastDocumentSessionId;
        if (message.lastDocumentSessionOperationId != null && message.hasOwnProperty("lastDocumentSessionOperationId"))
            object.lastDocumentSessionOperationId = message.lastDocumentSessionOperationId;
        if (message.currentDocumentSessionId != null && message.hasOwnProperty("currentDocumentSessionId"))
            object.currentDocumentSessionId = message.currentDocumentSessionId;
        if (message.currentDocumentSessionVersion != null && message.hasOwnProperty("currentDocumentSessionVersion"))
            object.currentDocumentSessionVersion = message.currentDocumentSessionVersion;
        if (message.currentDocumentSessionOperationId != null && message.hasOwnProperty("currentDocumentSessionOperationId"))
            object.currentDocumentSessionOperationId = message.currentDocumentSessionOperationId;
        return object;
    };

    GetDocumentDetailsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetDocumentDetailsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetDocumentDetailsResponse";
    };

    return GetDocumentDetailsResponse;
})();

$root.CommentDescriptor = (function() {

    function CommentDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentDescriptor.prototype.commentId = "";
    CommentDescriptor.prototype.commentThreadId = "";
    CommentDescriptor.prototype.userId = "";
    CommentDescriptor.prototype.content = "";
    CommentDescriptor.prototype.documentId = "";
    CommentDescriptor.prototype.createdAt = "";
    CommentDescriptor.prototype.attributes = "";

    CommentDescriptor.create = function create(properties) {
        return new CommentDescriptor(properties);
    };

    CommentDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(10).string(message.commentId);
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(18).string(message.commentThreadId);
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(26).string(message.userId);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            writer.uint32(34).string(message.content);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(42).string(message.documentId);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(50).string(message.createdAt);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(58).string(message.attributes);
        return writer;
    };

    CommentDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentId = reader.string();
                    break;
                }
            case 2: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 3: {
                    message.userId = reader.string();
                    break;
                }
            case 4: {
                    message.content = reader.string();
                    break;
                }
            case 5: {
                    message.documentId = reader.string();
                    break;
                }
            case 6: {
                    message.createdAt = reader.string();
                    break;
                }
            case 7: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.content != null && message.hasOwnProperty("content"))
            if (!$util.isString(message.content))
                return "content: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    CommentDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentDescriptor)
            return object;
        var message = new $root.CommentDescriptor();
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.content != null)
            message.content = String(object.content);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    CommentDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentId = "";
            object.commentThreadId = "";
            object.userId = "";
            object.content = "";
            object.documentId = "";
            object.createdAt = "";
            object.attributes = "";
        }
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = message.content;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    CommentDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentDescriptor";
    };

    return CommentDescriptor;
})();

$root.CommentsThreadDescriptor = (function() {

    function CommentsThreadDescriptor(properties) {
        this.comments = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsThreadDescriptor.prototype.commentThreadId = "";
    CommentsThreadDescriptor.prototype.comments = $util.emptyArray;
    CommentsThreadDescriptor.prototype.resolvedAt = "";
    CommentsThreadDescriptor.prototype.resolvedBy = "";
    CommentsThreadDescriptor.prototype.context = "";
    CommentsThreadDescriptor.prototype.createdAt = "";
    CommentsThreadDescriptor.prototype.deletedAt = "";
    CommentsThreadDescriptor.prototype.attributes = "";
    CommentsThreadDescriptor.prototype.unlinkedAt = "";

    CommentsThreadDescriptor.create = function create(properties) {
        return new CommentsThreadDescriptor(properties);
    };

    CommentsThreadDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.comments != null && message.comments.length)
            for (var i = 0; i < message.comments.length; ++i)
                $root.CommentDescriptor.encode(message.comments[i], writer.uint32(18).fork()).ldelim();
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
            writer.uint32(26).string(message.resolvedAt);
        if (message.resolvedBy != null && Object.hasOwnProperty.call(message, "resolvedBy"))
            writer.uint32(34).string(message.resolvedBy);
        if (message.context != null && Object.hasOwnProperty.call(message, "context"))
            writer.uint32(42).string(message.context);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(50).string(message.createdAt);
        if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
            writer.uint32(58).string(message.deletedAt);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(66).string(message.attributes);
        if (message.unlinkedAt != null && Object.hasOwnProperty.call(message, "unlinkedAt"))
            writer.uint32(74).string(message.unlinkedAt);
        return writer;
    };

    CommentsThreadDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsThreadDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsThreadDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.comments && message.comments.length))
                        message.comments = [];
                    message.comments.push($root.CommentDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            case 3: {
                    message.resolvedAt = reader.string();
                    break;
                }
            case 4: {
                    message.resolvedBy = reader.string();
                    break;
                }
            case 5: {
                    message.context = reader.string();
                    break;
                }
            case 6: {
                    message.createdAt = reader.string();
                    break;
                }
            case 7: {
                    message.deletedAt = reader.string();
                    break;
                }
            case 8: {
                    message.attributes = reader.string();
                    break;
                }
            case 9: {
                    message.unlinkedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsThreadDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsThreadDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.comments != null && message.hasOwnProperty("comments")) {
            if (!Array.isArray(message.comments))
                return "comments: array expected";
            for (var i = 0; i < message.comments.length; ++i) {
                var error = $root.CommentDescriptor.verify(message.comments[i]);
                if (error)
                    return "comments." + error;
            }
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            if (!$util.isString(message.resolvedAt))
                return "resolvedAt: string expected";
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            if (!$util.isString(message.resolvedBy))
                return "resolvedBy: string expected";
        if (message.context != null && message.hasOwnProperty("context"))
            if (!$util.isString(message.context))
                return "context: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            if (!$util.isString(message.deletedAt))
                return "deletedAt: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            if (!$util.isString(message.unlinkedAt))
                return "unlinkedAt: string expected";
        return null;
    };

    CommentsThreadDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsThreadDescriptor)
            return object;
        var message = new $root.CommentsThreadDescriptor();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.comments) {
            if (!Array.isArray(object.comments))
                throw TypeError(".CommentsThreadDescriptor.comments: array expected");
            message.comments = [];
            for (var i = 0; i < object.comments.length; ++i) {
                if (typeof object.comments[i] !== "object")
                    throw TypeError(".CommentsThreadDescriptor.comments: object expected");
                message.comments[i] = $root.CommentDescriptor.fromObject(object.comments[i]);
            }
        }
        if (object.resolvedAt != null)
            message.resolvedAt = String(object.resolvedAt);
        if (object.resolvedBy != null)
            message.resolvedBy = String(object.resolvedBy);
        if (object.context != null)
            message.context = String(object.context);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.deletedAt != null)
            message.deletedAt = String(object.deletedAt);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.unlinkedAt != null)
            message.unlinkedAt = String(object.unlinkedAt);
        return message;
    };

    CommentsThreadDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.comments = [];
        if (options.defaults) {
            object.commentThreadId = "";
            object.resolvedAt = "";
            object.resolvedBy = "";
            object.context = "";
            object.createdAt = "";
            object.deletedAt = "";
            object.attributes = "";
            object.unlinkedAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.comments && message.comments.length) {
            object.comments = [];
            for (var j = 0; j < message.comments.length; ++j)
                object.comments[j] = $root.CommentDescriptor.toObject(message.comments[j], options);
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            object.resolvedAt = message.resolvedAt;
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            object.resolvedBy = message.resolvedBy;
        if (message.context != null && message.hasOwnProperty("context"))
            object.context = message.context;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            object.deletedAt = message.deletedAt;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            object.unlinkedAt = message.unlinkedAt;
        return object;
    };

    CommentsThreadDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsThreadDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsThreadDescriptor";
    };

    return CommentsThreadDescriptor;
})();

$root.CommentThreadAddedCommentDescriptor = (function() {

    function CommentThreadAddedCommentDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentThreadAddedCommentDescriptor.prototype.commentId = "";
    CommentThreadAddedCommentDescriptor.prototype.createdAt = "";

    CommentThreadAddedCommentDescriptor.create = function create(properties) {
        return new CommentThreadAddedCommentDescriptor(properties);
    };

    CommentThreadAddedCommentDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(10).string(message.commentId);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(18).string(message.createdAt);
        return writer;
    };

    CommentThreadAddedCommentDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentThreadAddedCommentDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentThreadAddedCommentDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentId = reader.string();
                    break;
                }
            case 2: {
                    message.createdAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentThreadAddedCommentDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentThreadAddedCommentDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        return null;
    };

    CommentThreadAddedCommentDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentThreadAddedCommentDescriptor)
            return object;
        var message = new $root.CommentThreadAddedCommentDescriptor();
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        return message;
    };

    CommentThreadAddedCommentDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentId = "";
            object.createdAt = "";
        }
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        return object;
    };

    CommentThreadAddedCommentDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentThreadAddedCommentDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentThreadAddedCommentDescriptor";
    };

    return CommentThreadAddedCommentDescriptor;
})();

$root.CommentsV2AddCommentMessage = (function() {

    function CommentsV2AddCommentMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2AddCommentMessage.prototype.commentThreadId = "";
    CommentsV2AddCommentMessage.prototype.content = "";
    CommentsV2AddCommentMessage.prototype.documentId = "";
    CommentsV2AddCommentMessage.prototype.commentId = "";
    CommentsV2AddCommentMessage.prototype.createdAt = "";
    CommentsV2AddCommentMessage.prototype.userId = "";
    CommentsV2AddCommentMessage.prototype.attributes = "";
    CommentsV2AddCommentMessage.prototype.commentThread = null;

    CommentsV2AddCommentMessage.create = function create(properties) {
        return new CommentsV2AddCommentMessage(properties);
    };

    CommentsV2AddCommentMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            writer.uint32(18).string(message.content);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(26).string(message.documentId);
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(34).string(message.commentId);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(42).string(message.createdAt);
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(50).string(message.userId);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(58).string(message.attributes);
        if (message.commentThread != null && Object.hasOwnProperty.call(message, "commentThread"))
            $root.CommentsThreadDescriptor.encode(message.commentThread, writer.uint32(66).fork()).ldelim();
        return writer;
    };

    CommentsV2AddCommentMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2AddCommentMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2AddCommentMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.content = reader.string();
                    break;
                }
            case 3: {
                    message.documentId = reader.string();
                    break;
                }
            case 4: {
                    message.commentId = reader.string();
                    break;
                }
            case 5: {
                    message.createdAt = reader.string();
                    break;
                }
            case 6: {
                    message.userId = reader.string();
                    break;
                }
            case 7: {
                    message.attributes = reader.string();
                    break;
                }
            case 8: {
                    message.commentThread = $root.CommentsThreadDescriptor.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2AddCommentMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2AddCommentMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.content != null && message.hasOwnProperty("content"))
            if (!$util.isString(message.content))
                return "content: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.commentThread != null && message.hasOwnProperty("commentThread")) {
            var error = $root.CommentsThreadDescriptor.verify(message.commentThread);
            if (error)
                return "commentThread." + error;
        }
        return null;
    };

    CommentsV2AddCommentMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2AddCommentMessage)
            return object;
        var message = new $root.CommentsV2AddCommentMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.content != null)
            message.content = String(object.content);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.commentThread != null) {
            if (typeof object.commentThread !== "object")
                throw TypeError(".CommentsV2AddCommentMessage.commentThread: object expected");
            message.commentThread = $root.CommentsThreadDescriptor.fromObject(object.commentThread);
        }
        return message;
    };

    CommentsV2AddCommentMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.content = "";
            object.documentId = "";
            object.commentId = "";
            object.createdAt = "";
            object.userId = "";
            object.attributes = "";
            object.commentThread = null;
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = message.content;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.commentThread != null && message.hasOwnProperty("commentThread"))
            object.commentThread = $root.CommentsThreadDescriptor.toObject(message.commentThread, options);
        return object;
    };

    CommentsV2AddCommentMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2AddCommentMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2AddCommentMessage";
    };

    return CommentsV2AddCommentMessage;
})();

$root.CommentsV2AddCommentThreadMessage = (function() {

    function CommentsV2AddCommentThreadMessage(properties) {
        this.comments = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2AddCommentThreadMessage.prototype.documentId = "";
    CommentsV2AddCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2AddCommentThreadMessage.prototype.context = "";
    CommentsV2AddCommentThreadMessage.prototype.createdAt = "";
    CommentsV2AddCommentThreadMessage.prototype.resolvedAt = "";
    CommentsV2AddCommentThreadMessage.prototype.resolvedBy = "";
    CommentsV2AddCommentThreadMessage.prototype.attributes = "";
    CommentsV2AddCommentThreadMessage.prototype.deletedAt = "";
    CommentsV2AddCommentThreadMessage.prototype.comments = $util.emptyArray;

    CommentsV2AddCommentThreadMessage.create = function create(properties) {
        return new CommentsV2AddCommentThreadMessage(properties);
    };

    CommentsV2AddCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(18).string(message.commentThreadId);
        if (message.context != null && Object.hasOwnProperty.call(message, "context"))
            writer.uint32(26).string(message.context);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(34).string(message.createdAt);
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
            writer.uint32(42).string(message.resolvedAt);
        if (message.resolvedBy != null && Object.hasOwnProperty.call(message, "resolvedBy"))
            writer.uint32(50).string(message.resolvedBy);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(58).string(message.attributes);
        if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
            writer.uint32(66).string(message.deletedAt);
        if (message.comments != null && message.comments.length)
            for (var i = 0; i < message.comments.length; ++i)
                $root.CommentDescriptor.encode(message.comments[i], writer.uint32(74).fork()).ldelim();
        return writer;
    };

    CommentsV2AddCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2AddCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2AddCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            case 2: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 3: {
                    message.context = reader.string();
                    break;
                }
            case 4: {
                    message.createdAt = reader.string();
                    break;
                }
            case 5: {
                    message.resolvedAt = reader.string();
                    break;
                }
            case 6: {
                    message.resolvedBy = reader.string();
                    break;
                }
            case 7: {
                    message.attributes = reader.string();
                    break;
                }
            case 8: {
                    message.deletedAt = reader.string();
                    break;
                }
            case 9: {
                    if (!(message.comments && message.comments.length))
                        message.comments = [];
                    message.comments.push($root.CommentDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2AddCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2AddCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.context != null && message.hasOwnProperty("context"))
            if (!$util.isString(message.context))
                return "context: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            if (!$util.isString(message.resolvedAt))
                return "resolvedAt: string expected";
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            if (!$util.isString(message.resolvedBy))
                return "resolvedBy: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            if (!$util.isString(message.deletedAt))
                return "deletedAt: string expected";
        if (message.comments != null && message.hasOwnProperty("comments")) {
            if (!Array.isArray(message.comments))
                return "comments: array expected";
            for (var i = 0; i < message.comments.length; ++i) {
                var error = $root.CommentDescriptor.verify(message.comments[i]);
                if (error)
                    return "comments." + error;
            }
        }
        return null;
    };

    CommentsV2AddCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2AddCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2AddCommentThreadMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.context != null)
            message.context = String(object.context);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.resolvedAt != null)
            message.resolvedAt = String(object.resolvedAt);
        if (object.resolvedBy != null)
            message.resolvedBy = String(object.resolvedBy);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.deletedAt != null)
            message.deletedAt = String(object.deletedAt);
        if (object.comments) {
            if (!Array.isArray(object.comments))
                throw TypeError(".CommentsV2AddCommentThreadMessage.comments: array expected");
            message.comments = [];
            for (var i = 0; i < object.comments.length; ++i) {
                if (typeof object.comments[i] !== "object")
                    throw TypeError(".CommentsV2AddCommentThreadMessage.comments: object expected");
                message.comments[i] = $root.CommentDescriptor.fromObject(object.comments[i]);
            }
        }
        return message;
    };

    CommentsV2AddCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.comments = [];
        if (options.defaults) {
            object.documentId = "";
            object.commentThreadId = "";
            object.context = "";
            object.createdAt = "";
            object.resolvedAt = "";
            object.resolvedBy = "";
            object.attributes = "";
            object.deletedAt = "";
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.context != null && message.hasOwnProperty("context"))
            object.context = message.context;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            object.resolvedAt = message.resolvedAt;
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            object.resolvedBy = message.resolvedBy;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            object.deletedAt = message.deletedAt;
        if (message.comments && message.comments.length) {
            object.comments = [];
            for (var j = 0; j < message.comments.length; ++j)
                object.comments[j] = $root.CommentDescriptor.toObject(message.comments[j], options);
        }
        return object;
    };

    CommentsV2AddCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2AddCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2AddCommentThreadMessage";
    };

    return CommentsV2AddCommentThreadMessage;
})();

$root.CommentsV2ReopenCommentThreadMessage = (function() {

    function CommentsV2ReopenCommentThreadMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2ReopenCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2ReopenCommentThreadMessage.prototype.documentId = "";

    CommentsV2ReopenCommentThreadMessage.create = function create(properties) {
        return new CommentsV2ReopenCommentThreadMessage(properties);
    };

    CommentsV2ReopenCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        return writer;
    };

    CommentsV2ReopenCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2ReopenCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2ReopenCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2ReopenCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2ReopenCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2ReopenCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2ReopenCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2ReopenCommentThreadMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2ReopenCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2ReopenCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2ReopenCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2ReopenCommentThreadMessage";
    };

    return CommentsV2ReopenCommentThreadMessage;
})();

$root.CommentsV2ResolveCommentThreadMessage = (function() {

    function CommentsV2ResolveCommentThreadMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2ResolveCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2ResolveCommentThreadMessage.prototype.documentId = "";
    CommentsV2ResolveCommentThreadMessage.prototype.resolvedBy = "";
    CommentsV2ResolveCommentThreadMessage.prototype.resolvedAt = "";

    CommentsV2ResolveCommentThreadMessage.create = function create(properties) {
        return new CommentsV2ResolveCommentThreadMessage(properties);
    };

    CommentsV2ResolveCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.resolvedBy != null && Object.hasOwnProperty.call(message, "resolvedBy"))
            writer.uint32(26).string(message.resolvedBy);
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
            writer.uint32(34).string(message.resolvedAt);
        return writer;
    };

    CommentsV2ResolveCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2ResolveCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2ResolveCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.resolvedBy = reader.string();
                    break;
                }
            case 4: {
                    message.resolvedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2ResolveCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2ResolveCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            if (!$util.isString(message.resolvedBy))
                return "resolvedBy: string expected";
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            if (!$util.isString(message.resolvedAt))
                return "resolvedAt: string expected";
        return null;
    };

    CommentsV2ResolveCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2ResolveCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2ResolveCommentThreadMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.resolvedBy != null)
            message.resolvedBy = String(object.resolvedBy);
        if (object.resolvedAt != null)
            message.resolvedAt = String(object.resolvedAt);
        return message;
    };

    CommentsV2ResolveCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
            object.resolvedBy = "";
            object.resolvedAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            object.resolvedBy = message.resolvedBy;
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            object.resolvedAt = message.resolvedAt;
        return object;
    };

    CommentsV2ResolveCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2ResolveCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2ResolveCommentThreadMessage";
    };

    return CommentsV2ResolveCommentThreadMessage;
})();

$root.CommentsV2UpdateCommentThreadMessage = (function() {

    function CommentsV2UpdateCommentThreadMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2UpdateCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2UpdateCommentThreadMessage.prototype.documentId = "";
    CommentsV2UpdateCommentThreadMessage.prototype.context = "";
    CommentsV2UpdateCommentThreadMessage.prototype.attributes = "";
    CommentsV2UpdateCommentThreadMessage.prototype.unlinkedAt = "";

    CommentsV2UpdateCommentThreadMessage.create = function create(properties) {
        return new CommentsV2UpdateCommentThreadMessage(properties);
    };

    CommentsV2UpdateCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.context != null && Object.hasOwnProperty.call(message, "context"))
            writer.uint32(26).string(message.context);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(34).string(message.attributes);
        if (message.unlinkedAt != null && Object.hasOwnProperty.call(message, "unlinkedAt"))
            writer.uint32(42).string(message.unlinkedAt);
        return writer;
    };

    CommentsV2UpdateCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2UpdateCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2UpdateCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.context = reader.string();
                    break;
                }
            case 4: {
                    message.attributes = reader.string();
                    break;
                }
            case 5: {
                    message.unlinkedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2UpdateCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2UpdateCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.context != null && message.hasOwnProperty("context"))
            if (!$util.isString(message.context))
                return "context: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            if (!$util.isString(message.unlinkedAt))
                return "unlinkedAt: string expected";
        return null;
    };

    CommentsV2UpdateCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2UpdateCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2UpdateCommentThreadMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.context != null)
            message.context = String(object.context);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.unlinkedAt != null)
            message.unlinkedAt = String(object.unlinkedAt);
        return message;
    };

    CommentsV2UpdateCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
            object.context = "";
            object.attributes = "";
            object.unlinkedAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.context != null && message.hasOwnProperty("context"))
            object.context = message.context;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            object.unlinkedAt = message.unlinkedAt;
        return object;
    };

    CommentsV2UpdateCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2UpdateCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2UpdateCommentThreadMessage";
    };

    return CommentsV2UpdateCommentThreadMessage;
})();

$root.CommentsV2ConnectMessage = (function() {

    function CommentsV2ConnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2ConnectMessage.prototype.documentId = "";

    CommentsV2ConnectMessage.create = function create(properties) {
        return new CommentsV2ConnectMessage(properties);
    };

    CommentsV2ConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        return writer;
    };

    CommentsV2ConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2ConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2ConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2ConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2ConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2ConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2ConnectMessage)
            return object;
        var message = new $root.CommentsV2ConnectMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2ConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.documentId = "";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2ConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2ConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2ConnectMessage";
    };

    return CommentsV2ConnectMessage;
})();

$root.CommentsV2GetCommentThreadMessage = (function() {

    function CommentsV2GetCommentThreadMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2GetCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2GetCommentThreadMessage.prototype.documentId = "";

    CommentsV2GetCommentThreadMessage.create = function create(properties) {
        return new CommentsV2GetCommentThreadMessage(properties);
    };

    CommentsV2GetCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        return writer;
    };

    CommentsV2GetCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2GetCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2GetCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2GetCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2GetCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2GetCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2GetCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2GetCommentThreadMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2GetCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2GetCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2GetCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2GetCommentThreadMessage";
    };

    return CommentsV2GetCommentThreadMessage;
})();

$root.CommentsV2GetDocumentThreadsMessage = (function() {

    function CommentsV2GetDocumentThreadsMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2GetDocumentThreadsMessage.prototype.documentId = "";

    CommentsV2GetDocumentThreadsMessage.create = function create(properties) {
        return new CommentsV2GetDocumentThreadsMessage(properties);
    };

    CommentsV2GetDocumentThreadsMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        return writer;
    };

    CommentsV2GetDocumentThreadsMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2GetDocumentThreadsMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2GetDocumentThreadsMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2GetDocumentThreadsMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2GetDocumentThreadsMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2GetDocumentThreadsMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2GetDocumentThreadsMessage)
            return object;
        var message = new $root.CommentsV2GetDocumentThreadsMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2GetDocumentThreadsMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.documentId = "";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2GetDocumentThreadsMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2GetDocumentThreadsMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2GetDocumentThreadsMessage";
    };

    return CommentsV2GetDocumentThreadsMessage;
})();

$root.CommentsV2RemoveCommentMessage = (function() {

    function CommentsV2RemoveCommentMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2RemoveCommentMessage.prototype.commentThreadId = "";
    CommentsV2RemoveCommentMessage.prototype.commentId = "";
    CommentsV2RemoveCommentMessage.prototype.documentId = "";

    CommentsV2RemoveCommentMessage.create = function create(properties) {
        return new CommentsV2RemoveCommentMessage(properties);
    };

    CommentsV2RemoveCommentMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(18).string(message.commentId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(26).string(message.documentId);
        return writer;
    };

    CommentsV2RemoveCommentMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2RemoveCommentMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2RemoveCommentMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.commentId = reader.string();
                    break;
                }
            case 3: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2RemoveCommentMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2RemoveCommentMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2RemoveCommentMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2RemoveCommentMessage)
            return object;
        var message = new $root.CommentsV2RemoveCommentMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2RemoveCommentMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.commentId = "";
            object.documentId = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2RemoveCommentMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2RemoveCommentMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2RemoveCommentMessage";
    };

    return CommentsV2RemoveCommentMessage;
})();

$root.CommentsV2RemoveCommentThreadMessage = (function() {

    function CommentsV2RemoveCommentThreadMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2RemoveCommentThreadMessage.prototype.commentThreadId = "";
    CommentsV2RemoveCommentThreadMessage.prototype.documentId = "";

    CommentsV2RemoveCommentThreadMessage.create = function create(properties) {
        return new CommentsV2RemoveCommentThreadMessage(properties);
    };

    CommentsV2RemoveCommentThreadMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        return writer;
    };

    CommentsV2RemoveCommentThreadMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2RemoveCommentThreadMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2RemoveCommentThreadMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2RemoveCommentThreadMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2RemoveCommentThreadMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    CommentsV2RemoveCommentThreadMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2RemoveCommentThreadMessage)
            return object;
        var message = new $root.CommentsV2RemoveCommentThreadMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    CommentsV2RemoveCommentThreadMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    CommentsV2RemoveCommentThreadMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2RemoveCommentThreadMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2RemoveCommentThreadMessage";
    };

    return CommentsV2RemoveCommentThreadMessage;
})();

$root.CommentsV2UpdateCommentMessage = (function() {

    function CommentsV2UpdateCommentMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2UpdateCommentMessage.prototype.commentThreadId = "";
    CommentsV2UpdateCommentMessage.prototype.commentId = "";
    CommentsV2UpdateCommentMessage.prototype.content = "";
    CommentsV2UpdateCommentMessage.prototype.documentId = "";
    CommentsV2UpdateCommentMessage.prototype.attributes = "";
    CommentsV2UpdateCommentMessage.prototype.isAttributesUpdated = false;
    CommentsV2UpdateCommentMessage.prototype.commentThread = null;

    CommentsV2UpdateCommentMessage.create = function create(properties) {
        return new CommentsV2UpdateCommentMessage(properties);
    };

    CommentsV2UpdateCommentMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(18).string(message.commentId);
        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
            writer.uint32(26).string(message.content);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(34).string(message.documentId);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(42).string(message.attributes);
        if (message.isAttributesUpdated != null && Object.hasOwnProperty.call(message, "isAttributesUpdated"))
            writer.uint32(48).bool(message.isAttributesUpdated);
        if (message.commentThread != null && Object.hasOwnProperty.call(message, "commentThread"))
            $root.CommentsThreadDescriptor.encode(message.commentThread, writer.uint32(58).fork()).ldelim();
        return writer;
    };

    CommentsV2UpdateCommentMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2UpdateCommentMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2UpdateCommentMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.commentId = reader.string();
                    break;
                }
            case 3: {
                    message.content = reader.string();
                    break;
                }
            case 4: {
                    message.documentId = reader.string();
                    break;
                }
            case 5: {
                    message.attributes = reader.string();
                    break;
                }
            case 6: {
                    message.isAttributesUpdated = reader.bool();
                    break;
                }
            case 7: {
                    message.commentThread = $root.CommentsThreadDescriptor.decode(reader, reader.uint32());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2UpdateCommentMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2UpdateCommentMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.content != null && message.hasOwnProperty("content"))
            if (!$util.isString(message.content))
                return "content: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.isAttributesUpdated != null && message.hasOwnProperty("isAttributesUpdated"))
            if (typeof message.isAttributesUpdated !== "boolean")
                return "isAttributesUpdated: boolean expected";
        if (message.commentThread != null && message.hasOwnProperty("commentThread")) {
            var error = $root.CommentsThreadDescriptor.verify(message.commentThread);
            if (error)
                return "commentThread." + error;
        }
        return null;
    };

    CommentsV2UpdateCommentMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2UpdateCommentMessage)
            return object;
        var message = new $root.CommentsV2UpdateCommentMessage();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.content != null)
            message.content = String(object.content);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.isAttributesUpdated != null)
            message.isAttributesUpdated = Boolean(object.isAttributesUpdated);
        if (object.commentThread != null) {
            if (typeof object.commentThread !== "object")
                throw TypeError(".CommentsV2UpdateCommentMessage.commentThread: object expected");
            message.commentThread = $root.CommentsThreadDescriptor.fromObject(object.commentThread);
        }
        return message;
    };

    CommentsV2UpdateCommentMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.commentId = "";
            object.content = "";
            object.documentId = "";
            object.attributes = "";
            object.isAttributesUpdated = false;
            object.commentThread = null;
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.content != null && message.hasOwnProperty("content"))
            object.content = message.content;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.isAttributesUpdated != null && message.hasOwnProperty("isAttributesUpdated"))
            object.isAttributesUpdated = message.isAttributesUpdated;
        if (message.commentThread != null && message.hasOwnProperty("commentThread"))
            object.commentThread = $root.CommentsThreadDescriptor.toObject(message.commentThread, options);
        return object;
    };

    CommentsV2UpdateCommentMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2UpdateCommentMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2UpdateCommentMessage";
    };

    return CommentsV2UpdateCommentMessage;
})();

$root.CommentsV2AddCommentResponse = (function() {

    function CommentsV2AddCommentResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2AddCommentResponse.prototype.commentThreadId = "";
    CommentsV2AddCommentResponse.prototype.commentId = "";
    CommentsV2AddCommentResponse.prototype.createdAt = "";

    CommentsV2AddCommentResponse.create = function create(properties) {
        return new CommentsV2AddCommentResponse(properties);
    };

    CommentsV2AddCommentResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.commentId != null && Object.hasOwnProperty.call(message, "commentId"))
            writer.uint32(18).string(message.commentId);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(26).string(message.createdAt);
        return writer;
    };

    CommentsV2AddCommentResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2AddCommentResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2AddCommentResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.commentId = reader.string();
                    break;
                }
            case 3: {
                    message.createdAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2AddCommentResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2AddCommentResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            if (!$util.isString(message.commentId))
                return "commentId: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        return null;
    };

    CommentsV2AddCommentResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2AddCommentResponse)
            return object;
        var message = new $root.CommentsV2AddCommentResponse();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.commentId != null)
            message.commentId = String(object.commentId);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        return message;
    };

    CommentsV2AddCommentResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.commentId = "";
            object.createdAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.commentId != null && message.hasOwnProperty("commentId"))
            object.commentId = message.commentId;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        return object;
    };

    CommentsV2AddCommentResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2AddCommentResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2AddCommentResponse";
    };

    return CommentsV2AddCommentResponse;
})();

$root.CommentsV2AddCommentThreadResponse = (function() {

    function CommentsV2AddCommentThreadResponse(properties) {
        this.comments = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2AddCommentThreadResponse.prototype.commentThreadId = "";
    CommentsV2AddCommentThreadResponse.prototype.createdAt = "";
    CommentsV2AddCommentThreadResponse.prototype.comments = $util.emptyArray;

    CommentsV2AddCommentThreadResponse.create = function create(properties) {
        return new CommentsV2AddCommentThreadResponse(properties);
    };

    CommentsV2AddCommentThreadResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(18).string(message.createdAt);
        if (message.comments != null && message.comments.length)
            for (var i = 0; i < message.comments.length; ++i)
                $root.CommentThreadAddedCommentDescriptor.encode(message.comments[i], writer.uint32(26).fork()).ldelim();
        return writer;
    };

    CommentsV2AddCommentThreadResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2AddCommentThreadResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2AddCommentThreadResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.createdAt = reader.string();
                    break;
                }
            case 3: {
                    if (!(message.comments && message.comments.length))
                        message.comments = [];
                    message.comments.push($root.CommentThreadAddedCommentDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2AddCommentThreadResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2AddCommentThreadResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.comments != null && message.hasOwnProperty("comments")) {
            if (!Array.isArray(message.comments))
                return "comments: array expected";
            for (var i = 0; i < message.comments.length; ++i) {
                var error = $root.CommentThreadAddedCommentDescriptor.verify(message.comments[i]);
                if (error)
                    return "comments." + error;
            }
        }
        return null;
    };

    CommentsV2AddCommentThreadResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2AddCommentThreadResponse)
            return object;
        var message = new $root.CommentsV2AddCommentThreadResponse();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.comments) {
            if (!Array.isArray(object.comments))
                throw TypeError(".CommentsV2AddCommentThreadResponse.comments: array expected");
            message.comments = [];
            for (var i = 0; i < object.comments.length; ++i) {
                if (typeof object.comments[i] !== "object")
                    throw TypeError(".CommentsV2AddCommentThreadResponse.comments: object expected");
                message.comments[i] = $root.CommentThreadAddedCommentDescriptor.fromObject(object.comments[i]);
            }
        }
        return message;
    };

    CommentsV2AddCommentThreadResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.comments = [];
        if (options.defaults) {
            object.commentThreadId = "";
            object.createdAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.comments && message.comments.length) {
            object.comments = [];
            for (var j = 0; j < message.comments.length; ++j)
                object.comments[j] = $root.CommentThreadAddedCommentDescriptor.toObject(message.comments[j], options);
        }
        return object;
    };

    CommentsV2AddCommentThreadResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2AddCommentThreadResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2AddCommentThreadResponse";
    };

    return CommentsV2AddCommentThreadResponse;
})();

$root.CommentsV2ResolveCommentThreadResponse = (function() {

    function CommentsV2ResolveCommentThreadResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2ResolveCommentThreadResponse.prototype.commentThreadId = "";
    CommentsV2ResolveCommentThreadResponse.prototype.documentId = "";
    CommentsV2ResolveCommentThreadResponse.prototype.resolvedAt = "";
    CommentsV2ResolveCommentThreadResponse.prototype.resolvedBy = "";

    CommentsV2ResolveCommentThreadResponse.create = function create(properties) {
        return new CommentsV2ResolveCommentThreadResponse(properties);
    };

    CommentsV2ResolveCommentThreadResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
            writer.uint32(26).string(message.resolvedAt);
        if (message.resolvedBy != null && Object.hasOwnProperty.call(message, "resolvedBy"))
            writer.uint32(34).string(message.resolvedBy);
        return writer;
    };

    CommentsV2ResolveCommentThreadResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2ResolveCommentThreadResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2ResolveCommentThreadResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.resolvedAt = reader.string();
                    break;
                }
            case 4: {
                    message.resolvedBy = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2ResolveCommentThreadResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2ResolveCommentThreadResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            if (!$util.isString(message.resolvedAt))
                return "resolvedAt: string expected";
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            if (!$util.isString(message.resolvedBy))
                return "resolvedBy: string expected";
        return null;
    };

    CommentsV2ResolveCommentThreadResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2ResolveCommentThreadResponse)
            return object;
        var message = new $root.CommentsV2ResolveCommentThreadResponse();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.resolvedAt != null)
            message.resolvedAt = String(object.resolvedAt);
        if (object.resolvedBy != null)
            message.resolvedBy = String(object.resolvedBy);
        return message;
    };

    CommentsV2ResolveCommentThreadResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.commentThreadId = "";
            object.documentId = "";
            object.resolvedAt = "";
            object.resolvedBy = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            object.resolvedAt = message.resolvedAt;
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            object.resolvedBy = message.resolvedBy;
        return object;
    };

    CommentsV2ResolveCommentThreadResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2ResolveCommentThreadResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2ResolveCommentThreadResponse";
    };

    return CommentsV2ResolveCommentThreadResponse;
})();

$root.CommentsV2ConnectResponse = (function() {

    function CommentsV2ConnectResponse(properties) {
        this.threads = [];
        this.threadsV2 = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2ConnectResponse.prototype.channel = "";
    CommentsV2ConnectResponse.prototype.threads = $util.emptyArray;
    CommentsV2ConnectResponse.prototype.threadsV2 = $util.emptyArray;

    CommentsV2ConnectResponse.create = function create(properties) {
        return new CommentsV2ConnectResponse(properties);
    };

    CommentsV2ConnectResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(10).string(message.channel);
        if (message.threads != null && message.threads.length)
            for (var i = 0; i < message.threads.length; ++i)
                writer.uint32(18).string(message.threads[i]);
        if (message.threadsV2 != null && message.threadsV2.length)
            for (var i = 0; i < message.threadsV2.length; ++i)
                $root.CommentsThreadDescriptor.encode(message.threadsV2[i], writer.uint32(26).fork()).ldelim();
        return writer;
    };

    CommentsV2ConnectResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2ConnectResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2ConnectResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.threads && message.threads.length))
                        message.threads = [];
                    message.threads.push(reader.string());
                    break;
                }
            case 3: {
                    if (!(message.threadsV2 && message.threadsV2.length))
                        message.threadsV2 = [];
                    message.threadsV2.push($root.CommentsThreadDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2ConnectResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2ConnectResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.threads != null && message.hasOwnProperty("threads")) {
            if (!Array.isArray(message.threads))
                return "threads: array expected";
            for (var i = 0; i < message.threads.length; ++i)
                if (!$util.isString(message.threads[i]))
                    return "threads: string[] expected";
        }
        if (message.threadsV2 != null && message.hasOwnProperty("threadsV2")) {
            if (!Array.isArray(message.threadsV2))
                return "threadsV2: array expected";
            for (var i = 0; i < message.threadsV2.length; ++i) {
                var error = $root.CommentsThreadDescriptor.verify(message.threadsV2[i]);
                if (error)
                    return "threadsV2." + error;
            }
        }
        return null;
    };

    CommentsV2ConnectResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2ConnectResponse)
            return object;
        var message = new $root.CommentsV2ConnectResponse();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.threads) {
            if (!Array.isArray(object.threads))
                throw TypeError(".CommentsV2ConnectResponse.threads: array expected");
            message.threads = [];
            for (var i = 0; i < object.threads.length; ++i)
                message.threads[i] = String(object.threads[i]);
        }
        if (object.threadsV2) {
            if (!Array.isArray(object.threadsV2))
                throw TypeError(".CommentsV2ConnectResponse.threadsV2: array expected");
            message.threadsV2 = [];
            for (var i = 0; i < object.threadsV2.length; ++i) {
                if (typeof object.threadsV2[i] !== "object")
                    throw TypeError(".CommentsV2ConnectResponse.threadsV2: object expected");
                message.threadsV2[i] = $root.CommentsThreadDescriptor.fromObject(object.threadsV2[i]);
            }
        }
        return message;
    };

    CommentsV2ConnectResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.threads = [];
            object.threadsV2 = [];
        }
        if (options.defaults)
            object.channel = "";
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.threads && message.threads.length) {
            object.threads = [];
            for (var j = 0; j < message.threads.length; ++j)
                object.threads[j] = message.threads[j];
        }
        if (message.threadsV2 && message.threadsV2.length) {
            object.threadsV2 = [];
            for (var j = 0; j < message.threadsV2.length; ++j)
                object.threadsV2[j] = $root.CommentsThreadDescriptor.toObject(message.threadsV2[j], options);
        }
        return object;
    };

    CommentsV2ConnectResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2ConnectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2ConnectResponse";
    };

    return CommentsV2ConnectResponse;
})();

$root.CommentsV2GetCommentThreadResponse = (function() {

    function CommentsV2GetCommentThreadResponse(properties) {
        this.comments = [];
        this.commentsV2 = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2GetCommentThreadResponse.prototype.commentThreadId = "";
    CommentsV2GetCommentThreadResponse.prototype.comments = $util.emptyArray;
    CommentsV2GetCommentThreadResponse.prototype.commentsV2 = $util.emptyArray;
    CommentsV2GetCommentThreadResponse.prototype.resolvedAt = "";
    CommentsV2GetCommentThreadResponse.prototype.resolvedBy = "";
    CommentsV2GetCommentThreadResponse.prototype.context = "";
    CommentsV2GetCommentThreadResponse.prototype.createdAt = "";
    CommentsV2GetCommentThreadResponse.prototype.deletedAt = "";
    CommentsV2GetCommentThreadResponse.prototype.attributes = "";
    CommentsV2GetCommentThreadResponse.prototype.unlinkedAt = "";

    CommentsV2GetCommentThreadResponse.create = function create(properties) {
        return new CommentsV2GetCommentThreadResponse(properties);
    };

    CommentsV2GetCommentThreadResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.commentThreadId != null && Object.hasOwnProperty.call(message, "commentThreadId"))
            writer.uint32(10).string(message.commentThreadId);
        if (message.comments != null && message.comments.length)
            for (var i = 0; i < message.comments.length; ++i)
                writer.uint32(18).string(message.comments[i]);
        if (message.commentsV2 != null && message.commentsV2.length)
            for (var i = 0; i < message.commentsV2.length; ++i)
                $root.CommentDescriptor.encode(message.commentsV2[i], writer.uint32(26).fork()).ldelim();
        if (message.resolvedAt != null && Object.hasOwnProperty.call(message, "resolvedAt"))
            writer.uint32(34).string(message.resolvedAt);
        if (message.resolvedBy != null && Object.hasOwnProperty.call(message, "resolvedBy"))
            writer.uint32(42).string(message.resolvedBy);
        if (message.context != null && Object.hasOwnProperty.call(message, "context"))
            writer.uint32(50).string(message.context);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(58).string(message.createdAt);
        if (message.deletedAt != null && Object.hasOwnProperty.call(message, "deletedAt"))
            writer.uint32(66).string(message.deletedAt);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(74).string(message.attributes);
        if (message.unlinkedAt != null && Object.hasOwnProperty.call(message, "unlinkedAt"))
            writer.uint32(82).string(message.unlinkedAt);
        return writer;
    };

    CommentsV2GetCommentThreadResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2GetCommentThreadResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2GetCommentThreadResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.commentThreadId = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.comments && message.comments.length))
                        message.comments = [];
                    message.comments.push(reader.string());
                    break;
                }
            case 3: {
                    if (!(message.commentsV2 && message.commentsV2.length))
                        message.commentsV2 = [];
                    message.commentsV2.push($root.CommentDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            case 4: {
                    message.resolvedAt = reader.string();
                    break;
                }
            case 5: {
                    message.resolvedBy = reader.string();
                    break;
                }
            case 6: {
                    message.context = reader.string();
                    break;
                }
            case 7: {
                    message.createdAt = reader.string();
                    break;
                }
            case 8: {
                    message.deletedAt = reader.string();
                    break;
                }
            case 9: {
                    message.attributes = reader.string();
                    break;
                }
            case 10: {
                    message.unlinkedAt = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2GetCommentThreadResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2GetCommentThreadResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            if (!$util.isString(message.commentThreadId))
                return "commentThreadId: string expected";
        if (message.comments != null && message.hasOwnProperty("comments")) {
            if (!Array.isArray(message.comments))
                return "comments: array expected";
            for (var i = 0; i < message.comments.length; ++i)
                if (!$util.isString(message.comments[i]))
                    return "comments: string[] expected";
        }
        if (message.commentsV2 != null && message.hasOwnProperty("commentsV2")) {
            if (!Array.isArray(message.commentsV2))
                return "commentsV2: array expected";
            for (var i = 0; i < message.commentsV2.length; ++i) {
                var error = $root.CommentDescriptor.verify(message.commentsV2[i]);
                if (error)
                    return "commentsV2." + error;
            }
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            if (!$util.isString(message.resolvedAt))
                return "resolvedAt: string expected";
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            if (!$util.isString(message.resolvedBy))
                return "resolvedBy: string expected";
        if (message.context != null && message.hasOwnProperty("context"))
            if (!$util.isString(message.context))
                return "context: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            if (!$util.isString(message.deletedAt))
                return "deletedAt: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            if (!$util.isString(message.unlinkedAt))
                return "unlinkedAt: string expected";
        return null;
    };

    CommentsV2GetCommentThreadResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2GetCommentThreadResponse)
            return object;
        var message = new $root.CommentsV2GetCommentThreadResponse();
        if (object.commentThreadId != null)
            message.commentThreadId = String(object.commentThreadId);
        if (object.comments) {
            if (!Array.isArray(object.comments))
                throw TypeError(".CommentsV2GetCommentThreadResponse.comments: array expected");
            message.comments = [];
            for (var i = 0; i < object.comments.length; ++i)
                message.comments[i] = String(object.comments[i]);
        }
        if (object.commentsV2) {
            if (!Array.isArray(object.commentsV2))
                throw TypeError(".CommentsV2GetCommentThreadResponse.commentsV2: array expected");
            message.commentsV2 = [];
            for (var i = 0; i < object.commentsV2.length; ++i) {
                if (typeof object.commentsV2[i] !== "object")
                    throw TypeError(".CommentsV2GetCommentThreadResponse.commentsV2: object expected");
                message.commentsV2[i] = $root.CommentDescriptor.fromObject(object.commentsV2[i]);
            }
        }
        if (object.resolvedAt != null)
            message.resolvedAt = String(object.resolvedAt);
        if (object.resolvedBy != null)
            message.resolvedBy = String(object.resolvedBy);
        if (object.context != null)
            message.context = String(object.context);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.deletedAt != null)
            message.deletedAt = String(object.deletedAt);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.unlinkedAt != null)
            message.unlinkedAt = String(object.unlinkedAt);
        return message;
    };

    CommentsV2GetCommentThreadResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.comments = [];
            object.commentsV2 = [];
        }
        if (options.defaults) {
            object.commentThreadId = "";
            object.resolvedAt = "";
            object.resolvedBy = "";
            object.context = "";
            object.createdAt = "";
            object.deletedAt = "";
            object.attributes = "";
            object.unlinkedAt = "";
        }
        if (message.commentThreadId != null && message.hasOwnProperty("commentThreadId"))
            object.commentThreadId = message.commentThreadId;
        if (message.comments && message.comments.length) {
            object.comments = [];
            for (var j = 0; j < message.comments.length; ++j)
                object.comments[j] = message.comments[j];
        }
        if (message.commentsV2 && message.commentsV2.length) {
            object.commentsV2 = [];
            for (var j = 0; j < message.commentsV2.length; ++j)
                object.commentsV2[j] = $root.CommentDescriptor.toObject(message.commentsV2[j], options);
        }
        if (message.resolvedAt != null && message.hasOwnProperty("resolvedAt"))
            object.resolvedAt = message.resolvedAt;
        if (message.resolvedBy != null && message.hasOwnProperty("resolvedBy"))
            object.resolvedBy = message.resolvedBy;
        if (message.context != null && message.hasOwnProperty("context"))
            object.context = message.context;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.deletedAt != null && message.hasOwnProperty("deletedAt"))
            object.deletedAt = message.deletedAt;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.unlinkedAt != null && message.hasOwnProperty("unlinkedAt"))
            object.unlinkedAt = message.unlinkedAt;
        return object;
    };

    CommentsV2GetCommentThreadResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2GetCommentThreadResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2GetCommentThreadResponse";
    };

    return CommentsV2GetCommentThreadResponse;
})();

$root.CommentsV2GetDocumentThreadsResponse = (function() {

    function CommentsV2GetDocumentThreadsResponse(properties) {
        this.threads = [];
        this.threadsV2 = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    CommentsV2GetDocumentThreadsResponse.prototype.threads = $util.emptyArray;
    CommentsV2GetDocumentThreadsResponse.prototype.threadsV2 = $util.emptyArray;

    CommentsV2GetDocumentThreadsResponse.create = function create(properties) {
        return new CommentsV2GetDocumentThreadsResponse(properties);
    };

    CommentsV2GetDocumentThreadsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.threads != null && message.threads.length)
            for (var i = 0; i < message.threads.length; ++i)
                writer.uint32(10).string(message.threads[i]);
        if (message.threadsV2 != null && message.threadsV2.length)
            for (var i = 0; i < message.threadsV2.length; ++i)
                $root.CommentsThreadDescriptor.encode(message.threadsV2[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    CommentsV2GetDocumentThreadsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    CommentsV2GetDocumentThreadsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CommentsV2GetDocumentThreadsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.threads && message.threads.length))
                        message.threads = [];
                    message.threads.push(reader.string());
                    break;
                }
            case 2: {
                    if (!(message.threadsV2 && message.threadsV2.length))
                        message.threadsV2 = [];
                    message.threadsV2.push($root.CommentsThreadDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    CommentsV2GetDocumentThreadsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    CommentsV2GetDocumentThreadsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.threads != null && message.hasOwnProperty("threads")) {
            if (!Array.isArray(message.threads))
                return "threads: array expected";
            for (var i = 0; i < message.threads.length; ++i)
                if (!$util.isString(message.threads[i]))
                    return "threads: string[] expected";
        }
        if (message.threadsV2 != null && message.hasOwnProperty("threadsV2")) {
            if (!Array.isArray(message.threadsV2))
                return "threadsV2: array expected";
            for (var i = 0; i < message.threadsV2.length; ++i) {
                var error = $root.CommentsThreadDescriptor.verify(message.threadsV2[i]);
                if (error)
                    return "threadsV2." + error;
            }
        }
        return null;
    };

    CommentsV2GetDocumentThreadsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.CommentsV2GetDocumentThreadsResponse)
            return object;
        var message = new $root.CommentsV2GetDocumentThreadsResponse();
        if (object.threads) {
            if (!Array.isArray(object.threads))
                throw TypeError(".CommentsV2GetDocumentThreadsResponse.threads: array expected");
            message.threads = [];
            for (var i = 0; i < object.threads.length; ++i)
                message.threads[i] = String(object.threads[i]);
        }
        if (object.threadsV2) {
            if (!Array.isArray(object.threadsV2))
                throw TypeError(".CommentsV2GetDocumentThreadsResponse.threadsV2: array expected");
            message.threadsV2 = [];
            for (var i = 0; i < object.threadsV2.length; ++i) {
                if (typeof object.threadsV2[i] !== "object")
                    throw TypeError(".CommentsV2GetDocumentThreadsResponse.threadsV2: object expected");
                message.threadsV2[i] = $root.CommentsThreadDescriptor.fromObject(object.threadsV2[i]);
            }
        }
        return message;
    };

    CommentsV2GetDocumentThreadsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.threads = [];
            object.threadsV2 = [];
        }
        if (message.threads && message.threads.length) {
            object.threads = [];
            for (var j = 0; j < message.threads.length; ++j)
                object.threads[j] = message.threads[j];
        }
        if (message.threadsV2 && message.threadsV2.length) {
            object.threadsV2 = [];
            for (var j = 0; j < message.threadsV2.length; ++j)
                object.threadsV2[j] = $root.CommentsThreadDescriptor.toObject(message.threadsV2[j], options);
        }
        return object;
    };

    CommentsV2GetDocumentThreadsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    CommentsV2GetDocumentThreadsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/CommentsV2GetDocumentThreadsResponse";
    };

    return CommentsV2GetDocumentThreadsResponse;
})();

$root.KeyValueDescriptor = (function() {

    function KeyValueDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    KeyValueDescriptor.prototype.key = "";
    KeyValueDescriptor.prototype.value = "";

    KeyValueDescriptor.create = function create(properties) {
        return new KeyValueDescriptor(properties);
    };

    KeyValueDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
            writer.uint32(10).string(message.key);
        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
            writer.uint32(18).string(message.value);
        return writer;
    };

    KeyValueDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    KeyValueDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.KeyValueDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.key = reader.string();
                    break;
                }
            case 2: {
                    message.value = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    KeyValueDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    KeyValueDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.key != null && message.hasOwnProperty("key"))
            if (!$util.isString(message.key))
                return "key: string expected";
        if (message.value != null && message.hasOwnProperty("value"))
            if (!$util.isString(message.value))
                return "value: string expected";
        return null;
    };

    KeyValueDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.KeyValueDescriptor)
            return object;
        var message = new $root.KeyValueDescriptor();
        if (object.key != null)
            message.key = String(object.key);
        if (object.value != null)
            message.value = String(object.value);
        return message;
    };

    KeyValueDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.key = "";
            object.value = "";
        }
        if (message.key != null && message.hasOwnProperty("key"))
            object.key = message.key;
        if (message.value != null && message.hasOwnProperty("value"))
            object.value = message.value;
        return object;
    };

    KeyValueDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    KeyValueDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/KeyValueDescriptor";
    };

    return KeyValueDescriptor;
})();

$root.IsEditorBundleUploadedMessage = (function() {

    function IsEditorBundleUploadedMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    IsEditorBundleUploadedMessage.prototype.bundleVersion = "";

    IsEditorBundleUploadedMessage.create = function create(properties) {
        return new IsEditorBundleUploadedMessage(properties);
    };

    IsEditorBundleUploadedMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.bundleVersion != null && Object.hasOwnProperty.call(message, "bundleVersion"))
            writer.uint32(10).string(message.bundleVersion);
        return writer;
    };

    IsEditorBundleUploadedMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    IsEditorBundleUploadedMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.IsEditorBundleUploadedMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.bundleVersion = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    IsEditorBundleUploadedMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    IsEditorBundleUploadedMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            if (!$util.isString(message.bundleVersion))
                return "bundleVersion: string expected";
        return null;
    };

    IsEditorBundleUploadedMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.IsEditorBundleUploadedMessage)
            return object;
        var message = new $root.IsEditorBundleUploadedMessage();
        if (object.bundleVersion != null)
            message.bundleVersion = String(object.bundleVersion);
        return message;
    };

    IsEditorBundleUploadedMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.bundleVersion = "";
        if (message.bundleVersion != null && message.hasOwnProperty("bundleVersion"))
            object.bundleVersion = message.bundleVersion;
        return object;
    };

    IsEditorBundleUploadedMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    IsEditorBundleUploadedMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/IsEditorBundleUploadedMessage";
    };

    return IsEditorBundleUploadedMessage;
})();

$root.IsEditorBundleUploadedResponse = (function() {

    function IsEditorBundleUploadedResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    IsEditorBundleUploadedResponse.prototype.isUploaded = false;

    IsEditorBundleUploadedResponse.create = function create(properties) {
        return new IsEditorBundleUploadedResponse(properties);
    };

    IsEditorBundleUploadedResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.isUploaded != null && Object.hasOwnProperty.call(message, "isUploaded"))
            writer.uint32(8).bool(message.isUploaded);
        return writer;
    };

    IsEditorBundleUploadedResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    IsEditorBundleUploadedResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.IsEditorBundleUploadedResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.isUploaded = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    IsEditorBundleUploadedResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    IsEditorBundleUploadedResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.isUploaded != null && message.hasOwnProperty("isUploaded"))
            if (typeof message.isUploaded !== "boolean")
                return "isUploaded: boolean expected";
        return null;
    };

    IsEditorBundleUploadedResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.IsEditorBundleUploadedResponse)
            return object;
        var message = new $root.IsEditorBundleUploadedResponse();
        if (object.isUploaded != null)
            message.isUploaded = Boolean(object.isUploaded);
        return message;
    };

    IsEditorBundleUploadedResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.isUploaded = false;
        if (message.isUploaded != null && message.hasOwnProperty("isUploaded"))
            object.isUploaded = message.isUploaded;
        return object;
    };

    IsEditorBundleUploadedResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    IsEditorBundleUploadedResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/IsEditorBundleUploadedResponse";
    };

    return IsEditorBundleUploadedResponse;
})();

$root.RevisionDescriptor = (function() {

    function RevisionDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionDescriptor.prototype.revisionId = "";
    RevisionDescriptor.prototype.name = "";
    RevisionDescriptor.prototype.creatorId = "";
    RevisionDescriptor.prototype.authorsIds = "";
    RevisionDescriptor.prototype.diffData = "";
    RevisionDescriptor.prototype.createdAt = "";
    RevisionDescriptor.prototype.attributes = "";
    RevisionDescriptor.prototype.toVersion = 0;
    RevisionDescriptor.prototype.fromVersion = 0;
    RevisionDescriptor.prototype.isEmptyCurrent = false;

    RevisionDescriptor.create = function create(properties) {
        return new RevisionDescriptor(properties);
    };

    RevisionDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.revisionId != null && Object.hasOwnProperty.call(message, "revisionId"))
            writer.uint32(10).string(message.revisionId);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
            writer.uint32(18).string(message.name);
        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
            writer.uint32(26).string(message.creatorId);
        if (message.authorsIds != null && Object.hasOwnProperty.call(message, "authorsIds"))
            writer.uint32(34).string(message.authorsIds);
        if (message.diffData != null && Object.hasOwnProperty.call(message, "diffData"))
            writer.uint32(42).string(message.diffData);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(50).string(message.createdAt);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(58).string(message.attributes);
        if (message.toVersion != null && Object.hasOwnProperty.call(message, "toVersion"))
            writer.uint32(64).uint32(message.toVersion);
        if (message.fromVersion != null && Object.hasOwnProperty.call(message, "fromVersion"))
            writer.uint32(72).uint32(message.fromVersion);
        if (message.isEmptyCurrent != null && Object.hasOwnProperty.call(message, "isEmptyCurrent"))
            writer.uint32(80).bool(message.isEmptyCurrent);
        return writer;
    };

    RevisionDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.revisionId = reader.string();
                    break;
                }
            case 2: {
                    message.name = reader.string();
                    break;
                }
            case 3: {
                    message.creatorId = reader.string();
                    break;
                }
            case 4: {
                    message.authorsIds = reader.string();
                    break;
                }
            case 5: {
                    message.diffData = reader.string();
                    break;
                }
            case 6: {
                    message.createdAt = reader.string();
                    break;
                }
            case 7: {
                    message.attributes = reader.string();
                    break;
                }
            case 8: {
                    message.toVersion = reader.uint32();
                    break;
                }
            case 9: {
                    message.fromVersion = reader.uint32();
                    break;
                }
            case 10: {
                    message.isEmptyCurrent = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            if (!$util.isString(message.revisionId))
                return "revisionId: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
            if (!$util.isString(message.creatorId))
                return "creatorId: string expected";
        if (message.authorsIds != null && message.hasOwnProperty("authorsIds"))
            if (!$util.isString(message.authorsIds))
                return "authorsIds: string expected";
        if (message.diffData != null && message.hasOwnProperty("diffData"))
            if (!$util.isString(message.diffData))
                return "diffData: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            if (!$util.isInteger(message.toVersion))
                return "toVersion: integer expected";
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            if (!$util.isInteger(message.fromVersion))
                return "fromVersion: integer expected";
        if (message.isEmptyCurrent != null && message.hasOwnProperty("isEmptyCurrent"))
            if (typeof message.isEmptyCurrent !== "boolean")
                return "isEmptyCurrent: boolean expected";
        return null;
    };

    RevisionDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionDescriptor)
            return object;
        var message = new $root.RevisionDescriptor();
        if (object.revisionId != null)
            message.revisionId = String(object.revisionId);
        if (object.name != null)
            message.name = String(object.name);
        if (object.creatorId != null)
            message.creatorId = String(object.creatorId);
        if (object.authorsIds != null)
            message.authorsIds = String(object.authorsIds);
        if (object.diffData != null)
            message.diffData = String(object.diffData);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.toVersion != null)
            message.toVersion = object.toVersion >>> 0;
        if (object.fromVersion != null)
            message.fromVersion = object.fromVersion >>> 0;
        if (object.isEmptyCurrent != null)
            message.isEmptyCurrent = Boolean(object.isEmptyCurrent);
        return message;
    };

    RevisionDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.revisionId = "";
            object.name = "";
            object.creatorId = "";
            object.authorsIds = "";
            object.diffData = "";
            object.createdAt = "";
            object.attributes = "";
            object.toVersion = 0;
            object.fromVersion = 0;
            object.isEmptyCurrent = false;
        }
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            object.revisionId = message.revisionId;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
            object.creatorId = message.creatorId;
        if (message.authorsIds != null && message.hasOwnProperty("authorsIds"))
            object.authorsIds = message.authorsIds;
        if (message.diffData != null && message.hasOwnProperty("diffData"))
            object.diffData = message.diffData;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            object.toVersion = message.toVersion;
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            object.fromVersion = message.fromVersion;
        if (message.isEmptyCurrent != null && message.hasOwnProperty("isEmptyCurrent"))
            object.isEmptyCurrent = message.isEmptyCurrent;
        return object;
    };

    RevisionDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionDescriptor";
    };

    return RevisionDescriptor;
})();

$root.RevisionHistoryConnectMessage = (function() {

    function RevisionHistoryConnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryConnectMessage.prototype.documentId = "";

    RevisionHistoryConnectMessage.create = function create(properties) {
        return new RevisionHistoryConnectMessage(properties);
    };

    RevisionHistoryConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        return writer;
    };

    RevisionHistoryConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    RevisionHistoryConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryConnectMessage)
            return object;
        var message = new $root.RevisionHistoryConnectMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    RevisionHistoryConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.documentId = "";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    RevisionHistoryConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryConnectMessage";
    };

    return RevisionHistoryConnectMessage;
})();

$root.RevisionHistoryGetRevisionMessage = (function() {

    function RevisionHistoryGetRevisionMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryGetRevisionMessage.prototype.documentId = "";
    RevisionHistoryGetRevisionMessage.prototype.revisionId = "";

    RevisionHistoryGetRevisionMessage.create = function create(properties) {
        return new RevisionHistoryGetRevisionMessage(properties);
    };

    RevisionHistoryGetRevisionMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        if (message.revisionId != null && Object.hasOwnProperty.call(message, "revisionId"))
            writer.uint32(18).string(message.revisionId);
        return writer;
    };

    RevisionHistoryGetRevisionMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryGetRevisionMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryGetRevisionMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            case 2: {
                    message.revisionId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryGetRevisionMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryGetRevisionMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            if (!$util.isString(message.revisionId))
                return "revisionId: string expected";
        return null;
    };

    RevisionHistoryGetRevisionMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryGetRevisionMessage)
            return object;
        var message = new $root.RevisionHistoryGetRevisionMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.revisionId != null)
            message.revisionId = String(object.revisionId);
        return message;
    };

    RevisionHistoryGetRevisionMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.documentId = "";
            object.revisionId = "";
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            object.revisionId = message.revisionId;
        return object;
    };

    RevisionHistoryGetRevisionMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryGetRevisionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryGetRevisionMessage";
    };

    return RevisionHistoryGetRevisionMessage;
})();

$root.RevisionHistoryReconnectMessage = (function() {

    function RevisionHistoryReconnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryReconnectMessage.prototype.documentId = "";
    RevisionHistoryReconnectMessage.prototype.requestId = 0;

    RevisionHistoryReconnectMessage.create = function create(properties) {
        return new RevisionHistoryReconnectMessage(properties);
    };

    RevisionHistoryReconnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(16).uint32(message.requestId);
        return writer;
    };

    RevisionHistoryReconnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryReconnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryReconnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            case 2: {
                    message.requestId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryReconnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryReconnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        return null;
    };

    RevisionHistoryReconnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryReconnectMessage)
            return object;
        var message = new $root.RevisionHistoryReconnectMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.requestId != null)
            message.requestId = object.requestId >>> 0;
        return message;
    };

    RevisionHistoryReconnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.documentId = "";
            object.requestId = 0;
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        return object;
    };

    RevisionHistoryReconnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryReconnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryReconnectMessage";
    };

    return RevisionHistoryReconnectMessage;
})();

$root.RevisionHistoryUpdateRevisionsMessage = (function() {

    function RevisionHistoryUpdateRevisionsMessage(properties) {
        this.revisions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryUpdateRevisionsMessage.prototype.documentId = "";
    RevisionHistoryUpdateRevisionsMessage.prototype.requestId = 0;
    RevisionHistoryUpdateRevisionsMessage.prototype.revisions = $util.emptyArray;

    RevisionHistoryUpdateRevisionsMessage.create = function create(properties) {
        return new RevisionHistoryUpdateRevisionsMessage(properties);
    };

    RevisionHistoryUpdateRevisionsMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(16).uint32(message.requestId);
        if (message.revisions != null && message.revisions.length)
            for (var i = 0; i < message.revisions.length; ++i)
                $root.RevisionDescriptor.encode(message.revisions[i], writer.uint32(26).fork()).ldelim();
        return writer;
    };

    RevisionHistoryUpdateRevisionsMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryUpdateRevisionsMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryUpdateRevisionsMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            case 2: {
                    message.requestId = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.revisions && message.revisions.length))
                        message.revisions = [];
                    message.revisions.push($root.RevisionDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryUpdateRevisionsMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryUpdateRevisionsMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        if (message.revisions != null && message.hasOwnProperty("revisions")) {
            if (!Array.isArray(message.revisions))
                return "revisions: array expected";
            for (var i = 0; i < message.revisions.length; ++i) {
                var error = $root.RevisionDescriptor.verify(message.revisions[i]);
                if (error)
                    return "revisions." + error;
            }
        }
        return null;
    };

    RevisionHistoryUpdateRevisionsMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryUpdateRevisionsMessage)
            return object;
        var message = new $root.RevisionHistoryUpdateRevisionsMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.requestId != null)
            message.requestId = object.requestId >>> 0;
        if (object.revisions) {
            if (!Array.isArray(object.revisions))
                throw TypeError(".RevisionHistoryUpdateRevisionsMessage.revisions: array expected");
            message.revisions = [];
            for (var i = 0; i < object.revisions.length; ++i) {
                if (typeof object.revisions[i] !== "object")
                    throw TypeError(".RevisionHistoryUpdateRevisionsMessage.revisions: object expected");
                message.revisions[i] = $root.RevisionDescriptor.fromObject(object.revisions[i]);
            }
        }
        return message;
    };

    RevisionHistoryUpdateRevisionsMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.revisions = [];
        if (options.defaults) {
            object.documentId = "";
            object.requestId = 0;
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.revisions && message.revisions.length) {
            object.revisions = [];
            for (var j = 0; j < message.revisions.length; ++j)
                object.revisions[j] = $root.RevisionDescriptor.toObject(message.revisions[j], options);
        }
        return object;
    };

    RevisionHistoryUpdateRevisionsMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryUpdateRevisionsMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryUpdateRevisionsMessage";
    };

    return RevisionHistoryUpdateRevisionsMessage;
})();

$root.RevisionHistoryConnectResponse = (function() {

    function RevisionHistoryConnectResponse(properties) {
        this.revisions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryConnectResponse.prototype.channel = "";
    RevisionHistoryConnectResponse.prototype.requestId = 0;
    RevisionHistoryConnectResponse.prototype.revisions = $util.emptyArray;

    RevisionHistoryConnectResponse.create = function create(properties) {
        return new RevisionHistoryConnectResponse(properties);
    };

    RevisionHistoryConnectResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(10).string(message.channel);
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(16).uint32(message.requestId);
        if (message.revisions != null && message.revisions.length)
            for (var i = 0; i < message.revisions.length; ++i)
                $root.RevisionDescriptor.encode(message.revisions[i], writer.uint32(26).fork()).ldelim();
        return writer;
    };

    RevisionHistoryConnectResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryConnectResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryConnectResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.string();
                    break;
                }
            case 2: {
                    message.requestId = reader.uint32();
                    break;
                }
            case 3: {
                    if (!(message.revisions && message.revisions.length))
                        message.revisions = [];
                    message.revisions.push($root.RevisionDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryConnectResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryConnectResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        if (message.revisions != null && message.hasOwnProperty("revisions")) {
            if (!Array.isArray(message.revisions))
                return "revisions: array expected";
            for (var i = 0; i < message.revisions.length; ++i) {
                var error = $root.RevisionDescriptor.verify(message.revisions[i]);
                if (error)
                    return "revisions." + error;
            }
        }
        return null;
    };

    RevisionHistoryConnectResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryConnectResponse)
            return object;
        var message = new $root.RevisionHistoryConnectResponse();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.requestId != null)
            message.requestId = object.requestId >>> 0;
        if (object.revisions) {
            if (!Array.isArray(object.revisions))
                throw TypeError(".RevisionHistoryConnectResponse.revisions: array expected");
            message.revisions = [];
            for (var i = 0; i < object.revisions.length; ++i) {
                if (typeof object.revisions[i] !== "object")
                    throw TypeError(".RevisionHistoryConnectResponse.revisions: object expected");
                message.revisions[i] = $root.RevisionDescriptor.fromObject(object.revisions[i]);
            }
        }
        return message;
    };

    RevisionHistoryConnectResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.revisions = [];
        if (options.defaults) {
            object.channel = "";
            object.requestId = 0;
        }
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        if (message.revisions && message.revisions.length) {
            object.revisions = [];
            for (var j = 0; j < message.revisions.length; ++j)
                object.revisions[j] = $root.RevisionDescriptor.toObject(message.revisions[j], options);
        }
        return object;
    };

    RevisionHistoryConnectResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryConnectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryConnectResponse";
    };

    return RevisionHistoryConnectResponse;
})();

$root.RevisionHistoryGetRevisionResponse = (function() {

    function RevisionHistoryGetRevisionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryGetRevisionResponse.prototype.revisionId = "";
    RevisionHistoryGetRevisionResponse.prototype.name = "";
    RevisionHistoryGetRevisionResponse.prototype.creatorId = "";
    RevisionHistoryGetRevisionResponse.prototype.authorsIds = "";
    RevisionHistoryGetRevisionResponse.prototype.diffData = "";
    RevisionHistoryGetRevisionResponse.prototype.createdAt = "";
    RevisionHistoryGetRevisionResponse.prototype.attributes = "";
    RevisionHistoryGetRevisionResponse.prototype.toVersion = 0;
    RevisionHistoryGetRevisionResponse.prototype.fromVersion = 0;
    RevisionHistoryGetRevisionResponse.prototype.isEmptyCurrent = false;

    RevisionHistoryGetRevisionResponse.create = function create(properties) {
        return new RevisionHistoryGetRevisionResponse(properties);
    };

    RevisionHistoryGetRevisionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.revisionId != null && Object.hasOwnProperty.call(message, "revisionId"))
            writer.uint32(10).string(message.revisionId);
        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
            writer.uint32(18).string(message.name);
        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
            writer.uint32(26).string(message.creatorId);
        if (message.authorsIds != null && Object.hasOwnProperty.call(message, "authorsIds"))
            writer.uint32(34).string(message.authorsIds);
        if (message.diffData != null && Object.hasOwnProperty.call(message, "diffData"))
            writer.uint32(42).string(message.diffData);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(50).string(message.createdAt);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(58).string(message.attributes);
        if (message.toVersion != null && Object.hasOwnProperty.call(message, "toVersion"))
            writer.uint32(64).uint32(message.toVersion);
        if (message.fromVersion != null && Object.hasOwnProperty.call(message, "fromVersion"))
            writer.uint32(72).uint32(message.fromVersion);
        if (message.isEmptyCurrent != null && Object.hasOwnProperty.call(message, "isEmptyCurrent"))
            writer.uint32(80).bool(message.isEmptyCurrent);
        return writer;
    };

    RevisionHistoryGetRevisionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryGetRevisionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryGetRevisionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.revisionId = reader.string();
                    break;
                }
            case 2: {
                    message.name = reader.string();
                    break;
                }
            case 3: {
                    message.creatorId = reader.string();
                    break;
                }
            case 4: {
                    message.authorsIds = reader.string();
                    break;
                }
            case 5: {
                    message.diffData = reader.string();
                    break;
                }
            case 6: {
                    message.createdAt = reader.string();
                    break;
                }
            case 7: {
                    message.attributes = reader.string();
                    break;
                }
            case 8: {
                    message.toVersion = reader.uint32();
                    break;
                }
            case 9: {
                    message.fromVersion = reader.uint32();
                    break;
                }
            case 10: {
                    message.isEmptyCurrent = reader.bool();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryGetRevisionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryGetRevisionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            if (!$util.isString(message.revisionId))
                return "revisionId: string expected";
        if (message.name != null && message.hasOwnProperty("name"))
            if (!$util.isString(message.name))
                return "name: string expected";
        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
            if (!$util.isString(message.creatorId))
                return "creatorId: string expected";
        if (message.authorsIds != null && message.hasOwnProperty("authorsIds"))
            if (!$util.isString(message.authorsIds))
                return "authorsIds: string expected";
        if (message.diffData != null && message.hasOwnProperty("diffData"))
            if (!$util.isString(message.diffData))
                return "diffData: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            if (!$util.isInteger(message.toVersion))
                return "toVersion: integer expected";
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            if (!$util.isInteger(message.fromVersion))
                return "fromVersion: integer expected";
        if (message.isEmptyCurrent != null && message.hasOwnProperty("isEmptyCurrent"))
            if (typeof message.isEmptyCurrent !== "boolean")
                return "isEmptyCurrent: boolean expected";
        return null;
    };

    RevisionHistoryGetRevisionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryGetRevisionResponse)
            return object;
        var message = new $root.RevisionHistoryGetRevisionResponse();
        if (object.revisionId != null)
            message.revisionId = String(object.revisionId);
        if (object.name != null)
            message.name = String(object.name);
        if (object.creatorId != null)
            message.creatorId = String(object.creatorId);
        if (object.authorsIds != null)
            message.authorsIds = String(object.authorsIds);
        if (object.diffData != null)
            message.diffData = String(object.diffData);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        if (object.toVersion != null)
            message.toVersion = object.toVersion >>> 0;
        if (object.fromVersion != null)
            message.fromVersion = object.fromVersion >>> 0;
        if (object.isEmptyCurrent != null)
            message.isEmptyCurrent = Boolean(object.isEmptyCurrent);
        return message;
    };

    RevisionHistoryGetRevisionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.revisionId = "";
            object.name = "";
            object.creatorId = "";
            object.authorsIds = "";
            object.diffData = "";
            object.createdAt = "";
            object.attributes = "";
            object.toVersion = 0;
            object.fromVersion = 0;
            object.isEmptyCurrent = false;
        }
        if (message.revisionId != null && message.hasOwnProperty("revisionId"))
            object.revisionId = message.revisionId;
        if (message.name != null && message.hasOwnProperty("name"))
            object.name = message.name;
        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
            object.creatorId = message.creatorId;
        if (message.authorsIds != null && message.hasOwnProperty("authorsIds"))
            object.authorsIds = message.authorsIds;
        if (message.diffData != null && message.hasOwnProperty("diffData"))
            object.diffData = message.diffData;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        if (message.toVersion != null && message.hasOwnProperty("toVersion"))
            object.toVersion = message.toVersion;
        if (message.fromVersion != null && message.hasOwnProperty("fromVersion"))
            object.fromVersion = message.fromVersion;
        if (message.isEmptyCurrent != null && message.hasOwnProperty("isEmptyCurrent"))
            object.isEmptyCurrent = message.isEmptyCurrent;
        return object;
    };

    RevisionHistoryGetRevisionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryGetRevisionResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryGetRevisionResponse";
    };

    return RevisionHistoryGetRevisionResponse;
})();

$root.RevisionHistoryUpdateRevisionsResponse = (function() {

    function RevisionHistoryUpdateRevisionsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    RevisionHistoryUpdateRevisionsResponse.prototype.requestId = 0;

    RevisionHistoryUpdateRevisionsResponse.create = function create(properties) {
        return new RevisionHistoryUpdateRevisionsResponse(properties);
    };

    RevisionHistoryUpdateRevisionsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
            writer.uint32(8).uint32(message.requestId);
        return writer;
    };

    RevisionHistoryUpdateRevisionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    RevisionHistoryUpdateRevisionsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.RevisionHistoryUpdateRevisionsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.requestId = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    RevisionHistoryUpdateRevisionsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    RevisionHistoryUpdateRevisionsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            if (!$util.isInteger(message.requestId))
                return "requestId: integer expected";
        return null;
    };

    RevisionHistoryUpdateRevisionsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.RevisionHistoryUpdateRevisionsResponse)
            return object;
        var message = new $root.RevisionHistoryUpdateRevisionsResponse();
        if (object.requestId != null)
            message.requestId = object.requestId >>> 0;
        return message;
    };

    RevisionHistoryUpdateRevisionsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.requestId = 0;
        if (message.requestId != null && message.hasOwnProperty("requestId"))
            object.requestId = message.requestId;
        return object;
    };

    RevisionHistoryUpdateRevisionsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    RevisionHistoryUpdateRevisionsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/RevisionHistoryUpdateRevisionsResponse";
    };

    return RevisionHistoryUpdateRevisionsResponse;
})();

$root.SessionsSocketDescriptor = (function() {

    function SessionsSocketDescriptor(properties) {
        this.permissions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SessionsSocketDescriptor.prototype.session = "";
    SessionsSocketDescriptor.prototype.user = "";
    SessionsSocketDescriptor.prototype.role = "";
    SessionsSocketDescriptor.prototype.permissions = $util.emptyArray;

    SessionsSocketDescriptor.create = function create(properties) {
        return new SessionsSocketDescriptor(properties);
    };

    SessionsSocketDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.session != null && Object.hasOwnProperty.call(message, "session"))
            writer.uint32(10).string(message.session);
        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
            writer.uint32(18).string(message.user);
        if (message.role != null && Object.hasOwnProperty.call(message, "role"))
            writer.uint32(26).string(message.role);
        if (message.permissions != null && message.permissions.length)
            for (var i = 0; i < message.permissions.length; ++i)
                writer.uint32(34).string(message.permissions[i]);
        return writer;
    };

    SessionsSocketDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SessionsSocketDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionsSocketDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.session = reader.string();
                    break;
                }
            case 2: {
                    message.user = reader.string();
                    break;
                }
            case 3: {
                    message.role = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.permissions && message.permissions.length))
                        message.permissions = [];
                    message.permissions.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SessionsSocketDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SessionsSocketDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.session != null && message.hasOwnProperty("session"))
            if (!$util.isString(message.session))
                return "session: string expected";
        if (message.user != null && message.hasOwnProperty("user"))
            if (!$util.isString(message.user))
                return "user: string expected";
        if (message.role != null && message.hasOwnProperty("role"))
            if (!$util.isString(message.role))
                return "role: string expected";
        if (message.permissions != null && message.hasOwnProperty("permissions")) {
            if (!Array.isArray(message.permissions))
                return "permissions: array expected";
            for (var i = 0; i < message.permissions.length; ++i)
                if (!$util.isString(message.permissions[i]))
                    return "permissions: string[] expected";
        }
        return null;
    };

    SessionsSocketDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionsSocketDescriptor)
            return object;
        var message = new $root.SessionsSocketDescriptor();
        if (object.session != null)
            message.session = String(object.session);
        if (object.user != null)
            message.user = String(object.user);
        if (object.role != null)
            message.role = String(object.role);
        if (object.permissions) {
            if (!Array.isArray(object.permissions))
                throw TypeError(".SessionsSocketDescriptor.permissions: array expected");
            message.permissions = [];
            for (var i = 0; i < object.permissions.length; ++i)
                message.permissions[i] = String(object.permissions[i]);
        }
        return message;
    };

    SessionsSocketDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.permissions = [];
        if (options.defaults) {
            object.session = "";
            object.user = "";
            object.role = "";
        }
        if (message.session != null && message.hasOwnProperty("session"))
            object.session = message.session;
        if (message.user != null && message.hasOwnProperty("user"))
            object.user = message.user;
        if (message.role != null && message.hasOwnProperty("role"))
            object.role = message.role;
        if (message.permissions && message.permissions.length) {
            object.permissions = [];
            for (var j = 0; j < message.permissions.length; ++j)
                object.permissions[j] = message.permissions[j];
        }
        return object;
    };

    SessionsSocketDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SessionsSocketDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SessionsSocketDescriptor";
    };

    return SessionsSocketDescriptor;
})();

$root.SessionsConnectMessage = (function() {

    function SessionsConnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SessionsConnectMessage.prototype.id = "";
    SessionsConnectMessage.prototype.sessionType = 0;

    SessionsConnectMessage.create = function create(properties) {
        return new SessionsConnectMessage(properties);
    };

    SessionsConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.sessionType != null && Object.hasOwnProperty.call(message, "sessionType"))
            writer.uint32(16).uint32(message.sessionType);
        return writer;
    };

    SessionsConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SessionsConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionsConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.sessionType = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SessionsConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SessionsConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.sessionType != null && message.hasOwnProperty("sessionType"))
            if (!$util.isInteger(message.sessionType))
                return "sessionType: integer expected";
        return null;
    };

    SessionsConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionsConnectMessage)
            return object;
        var message = new $root.SessionsConnectMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.sessionType != null)
            message.sessionType = object.sessionType >>> 0;
        return message;
    };

    SessionsConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.sessionType = 0;
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.sessionType != null && message.hasOwnProperty("sessionType"))
            object.sessionType = message.sessionType;
        return object;
    };

    SessionsConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SessionsConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SessionsConnectMessage";
    };

    return SessionsConnectMessage;
})();

$root.SocketConnectMessage = (function() {

    function SocketConnectMessage(properties) {
        this.permissions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SocketConnectMessage.prototype.id = "";
    SocketConnectMessage.prototype.userId = "";
    SocketConnectMessage.prototype.role = "";
    SocketConnectMessage.prototype.permissions = $util.emptyArray;

    SocketConnectMessage.create = function create(properties) {
        return new SocketConnectMessage(properties);
    };

    SocketConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
            writer.uint32(18).string(message.userId);
        if (message.role != null && Object.hasOwnProperty.call(message, "role"))
            writer.uint32(26).string(message.role);
        if (message.permissions != null && message.permissions.length)
            for (var i = 0; i < message.permissions.length; ++i)
                writer.uint32(34).string(message.permissions[i]);
        return writer;
    };

    SocketConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SocketConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SocketConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.userId = reader.string();
                    break;
                }
            case 3: {
                    message.role = reader.string();
                    break;
                }
            case 4: {
                    if (!(message.permissions && message.permissions.length))
                        message.permissions = [];
                    message.permissions.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SocketConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SocketConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.userId != null && message.hasOwnProperty("userId"))
            if (!$util.isString(message.userId))
                return "userId: string expected";
        if (message.role != null && message.hasOwnProperty("role"))
            if (!$util.isString(message.role))
                return "role: string expected";
        if (message.permissions != null && message.hasOwnProperty("permissions")) {
            if (!Array.isArray(message.permissions))
                return "permissions: array expected";
            for (var i = 0; i < message.permissions.length; ++i)
                if (!$util.isString(message.permissions[i]))
                    return "permissions: string[] expected";
        }
        return null;
    };

    SocketConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SocketConnectMessage)
            return object;
        var message = new $root.SocketConnectMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.userId != null)
            message.userId = String(object.userId);
        if (object.role != null)
            message.role = String(object.role);
        if (object.permissions) {
            if (!Array.isArray(object.permissions))
                throw TypeError(".SocketConnectMessage.permissions: array expected");
            message.permissions = [];
            for (var i = 0; i < object.permissions.length; ++i)
                message.permissions[i] = String(object.permissions[i]);
        }
        return message;
    };

    SocketConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.permissions = [];
        if (options.defaults) {
            object.id = "";
            object.userId = "";
            object.role = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.userId != null && message.hasOwnProperty("userId"))
            object.userId = message.userId;
        if (message.role != null && message.hasOwnProperty("role"))
            object.role = message.role;
        if (message.permissions && message.permissions.length) {
            object.permissions = [];
            for (var j = 0; j < message.permissions.length; ++j)
                object.permissions[j] = message.permissions[j];
        }
        return object;
    };

    SocketConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SocketConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SocketConnectMessage";
    };

    return SocketConnectMessage;
})();

$root.SocketDisconnectMessage = (function() {

    function SocketDisconnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SocketDisconnectMessage.prototype.id = "";

    SocketDisconnectMessage.create = function create(properties) {
        return new SocketDisconnectMessage(properties);
    };

    SocketDisconnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        return writer;
    };

    SocketDisconnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SocketDisconnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SocketDisconnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SocketDisconnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SocketDisconnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        return null;
    };

    SocketDisconnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.SocketDisconnectMessage)
            return object;
        var message = new $root.SocketDisconnectMessage();
        if (object.id != null)
            message.id = String(object.id);
        return message;
    };

    SocketDisconnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.id = "";
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        return object;
    };

    SocketDisconnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SocketDisconnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SocketDisconnectMessage";
    };

    return SocketDisconnectMessage;
})();

$root.SessionsConnectResponse = (function() {

    function SessionsConnectResponse(properties) {
        this.sockets = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SessionsConnectResponse.prototype.channel = "";
    SessionsConnectResponse.prototype.sockets = $util.emptyArray;

    SessionsConnectResponse.create = function create(properties) {
        return new SessionsConnectResponse(properties);
    };

    SessionsConnectResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(10).string(message.channel);
        if (message.sockets != null && message.sockets.length)
            for (var i = 0; i < message.sockets.length; ++i)
                $root.SessionsSocketDescriptor.encode(message.sockets[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    SessionsConnectResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SessionsConnectResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SessionsConnectResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.sockets && message.sockets.length))
                        message.sockets = [];
                    message.sockets.push($root.SessionsSocketDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SessionsConnectResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SessionsConnectResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.sockets != null && message.hasOwnProperty("sockets")) {
            if (!Array.isArray(message.sockets))
                return "sockets: array expected";
            for (var i = 0; i < message.sockets.length; ++i) {
                var error = $root.SessionsSocketDescriptor.verify(message.sockets[i]);
                if (error)
                    return "sockets." + error;
            }
        }
        return null;
    };

    SessionsConnectResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.SessionsConnectResponse)
            return object;
        var message = new $root.SessionsConnectResponse();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.sockets) {
            if (!Array.isArray(object.sockets))
                throw TypeError(".SessionsConnectResponse.sockets: array expected");
            message.sockets = [];
            for (var i = 0; i < object.sockets.length; ++i) {
                if (typeof object.sockets[i] !== "object")
                    throw TypeError(".SessionsConnectResponse.sockets: object expected");
                message.sockets[i] = $root.SessionsSocketDescriptor.fromObject(object.sockets[i]);
            }
        }
        return message;
    };

    SessionsConnectResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.sockets = [];
        if (options.defaults)
            object.channel = "";
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.sockets && message.sockets.length) {
            object.sockets = [];
            for (var j = 0; j < message.sockets.length; ++j)
                object.sockets[j] = $root.SessionsSocketDescriptor.toObject(message.sockets[j], options);
        }
        return object;
    };

    SessionsConnectResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SessionsConnectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SessionsConnectResponse";
    };

    return SessionsConnectResponse;
})();

$root.SuggestionDescriptor = (function() {

    function SuggestionDescriptor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    SuggestionDescriptor.prototype.id = "";
    SuggestionDescriptor.prototype.authorId = "";
    SuggestionDescriptor.prototype.type = "";
    SuggestionDescriptor.prototype.createdAt = "";
    SuggestionDescriptor.prototype.data = "";
    SuggestionDescriptor.prototype.hasComments = false;
    SuggestionDescriptor.prototype.state = "";
    SuggestionDescriptor.prototype.attributes = "";

    SuggestionDescriptor.create = function create(properties) {
        return new SuggestionDescriptor(properties);
    };

    SuggestionDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
            writer.uint32(18).string(message.authorId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(26).string(message.type);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(34).string(message.createdAt);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).string(message.data);
        if (message.hasComments != null && Object.hasOwnProperty.call(message, "hasComments"))
            writer.uint32(48).bool(message.hasComments);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(58).string(message.state);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(66).string(message.attributes);
        return writer;
    };

    SuggestionDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    SuggestionDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SuggestionDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.authorId = reader.string();
                    break;
                }
            case 3: {
                    message.type = reader.string();
                    break;
                }
            case 4: {
                    message.createdAt = reader.string();
                    break;
                }
            case 5: {
                    message.data = reader.string();
                    break;
                }
            case 6: {
                    message.hasComments = reader.bool();
                    break;
                }
            case 7: {
                    message.state = reader.string();
                    break;
                }
            case 8: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    SuggestionDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    SuggestionDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            if (!$util.isString(message.authorId))
                return "authorId: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            if (typeof message.hasComments !== "boolean")
                return "hasComments: boolean expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    SuggestionDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.SuggestionDescriptor)
            return object;
        var message = new $root.SuggestionDescriptor();
        if (object.id != null)
            message.id = String(object.id);
        if (object.authorId != null)
            message.authorId = String(object.authorId);
        if (object.type != null)
            message.type = String(object.type);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.data != null)
            message.data = String(object.data);
        if (object.hasComments != null)
            message.hasComments = Boolean(object.hasComments);
        if (object.state != null)
            message.state = String(object.state);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    SuggestionDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.authorId = "";
            object.type = "";
            object.createdAt = "";
            object.data = "";
            object.hasComments = false;
            object.state = "";
            object.attributes = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            object.authorId = message.authorId;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            object.hasComments = message.hasComments;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    SuggestionDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    SuggestionDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/SuggestionDescriptor";
    };

    return SuggestionDescriptor;
})();

$root.TrackChangesAddSuggestionMessage = (function() {

    function TrackChangesAddSuggestionMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesAddSuggestionMessage.prototype.id = "";
    TrackChangesAddSuggestionMessage.prototype.documentId = "";
    TrackChangesAddSuggestionMessage.prototype.type = "";
    TrackChangesAddSuggestionMessage.prototype.data = "";
    TrackChangesAddSuggestionMessage.prototype.originalSuggestionId = "";
    TrackChangesAddSuggestionMessage.prototype.attributes = "";

    TrackChangesAddSuggestionMessage.create = function create(properties) {
        return new TrackChangesAddSuggestionMessage(properties);
    };

    TrackChangesAddSuggestionMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(26).string(message.type);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(34).string(message.data);
        if (message.originalSuggestionId != null && Object.hasOwnProperty.call(message, "originalSuggestionId"))
            writer.uint32(42).string(message.originalSuggestionId);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(50).string(message.attributes);
        return writer;
    };

    TrackChangesAddSuggestionMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesAddSuggestionMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesAddSuggestionMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.type = reader.string();
                    break;
                }
            case 4: {
                    message.data = reader.string();
                    break;
                }
            case 5: {
                    message.originalSuggestionId = reader.string();
                    break;
                }
            case 6: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesAddSuggestionMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesAddSuggestionMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.originalSuggestionId != null && message.hasOwnProperty("originalSuggestionId"))
            if (!$util.isString(message.originalSuggestionId))
                return "originalSuggestionId: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    TrackChangesAddSuggestionMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesAddSuggestionMessage)
            return object;
        var message = new $root.TrackChangesAddSuggestionMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.type != null)
            message.type = String(object.type);
        if (object.data != null)
            message.data = String(object.data);
        if (object.originalSuggestionId != null)
            message.originalSuggestionId = String(object.originalSuggestionId);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    TrackChangesAddSuggestionMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.documentId = "";
            object.type = "";
            object.data = "";
            object.originalSuggestionId = "";
            object.attributes = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.originalSuggestionId != null && message.hasOwnProperty("originalSuggestionId"))
            object.originalSuggestionId = message.originalSuggestionId;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    TrackChangesAddSuggestionMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesAddSuggestionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesAddSuggestionMessage";
    };

    return TrackChangesAddSuggestionMessage;
})();

$root.TrackChangesBatchUpdateSuggestionsStateMessage = (function() {

    function TrackChangesBatchUpdateSuggestionsStateMessage(properties) {
        this.ids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesBatchUpdateSuggestionsStateMessage.prototype.ids = $util.emptyArray;
    TrackChangesBatchUpdateSuggestionsStateMessage.prototype.documentId = "";
    TrackChangesBatchUpdateSuggestionsStateMessage.prototype.state = "";

    TrackChangesBatchUpdateSuggestionsStateMessage.create = function create(properties) {
        return new TrackChangesBatchUpdateSuggestionsStateMessage(properties);
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ids != null && message.ids.length)
            for (var i = 0; i < message.ids.length; ++i)
                writer.uint32(10).string(message.ids[i]);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(26).string(message.state);
        return writer;
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesBatchUpdateSuggestionsStateMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.state = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ids != null && message.hasOwnProperty("ids")) {
            if (!Array.isArray(message.ids))
                return "ids: array expected";
            for (var i = 0; i < message.ids.length; ++i)
                if (!$util.isString(message.ids[i]))
                    return "ids: string[] expected";
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        return null;
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesBatchUpdateSuggestionsStateMessage)
            return object;
        var message = new $root.TrackChangesBatchUpdateSuggestionsStateMessage();
        if (object.ids) {
            if (!Array.isArray(object.ids))
                throw TypeError(".TrackChangesBatchUpdateSuggestionsStateMessage.ids: array expected");
            message.ids = [];
            for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
        }
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.state != null)
            message.state = String(object.state);
        return message;
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.ids = [];
        if (options.defaults) {
            object.documentId = "";
            object.state = "";
        }
        if (message.ids && message.ids.length) {
            object.ids = [];
            for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
        }
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        return object;
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesBatchUpdateSuggestionsStateMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesBatchUpdateSuggestionsStateMessage";
    };

    return TrackChangesBatchUpdateSuggestionsStateMessage;
})();

$root.TrackChangesConnectMessage = (function() {

    function TrackChangesConnectMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesConnectMessage.prototype.documentId = "";

    TrackChangesConnectMessage.create = function create(properties) {
        return new TrackChangesConnectMessage(properties);
    };

    TrackChangesConnectMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        return writer;
    };

    TrackChangesConnectMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesConnectMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesConnectMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesConnectMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesConnectMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    TrackChangesConnectMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesConnectMessage)
            return object;
        var message = new $root.TrackChangesConnectMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    TrackChangesConnectMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.documentId = "";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    TrackChangesConnectMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesConnectMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesConnectMessage";
    };

    return TrackChangesConnectMessage;
})();

$root.TrackChangesGetAllSuggestionMessage = (function() {

    function TrackChangesGetAllSuggestionMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesGetAllSuggestionMessage.prototype.documentId = "";

    TrackChangesGetAllSuggestionMessage.create = function create(properties) {
        return new TrackChangesGetAllSuggestionMessage(properties);
    };

    TrackChangesGetAllSuggestionMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(10).string(message.documentId);
        return writer;
    };

    TrackChangesGetAllSuggestionMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesGetAllSuggestionMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesGetAllSuggestionMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesGetAllSuggestionMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesGetAllSuggestionMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    TrackChangesGetAllSuggestionMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesGetAllSuggestionMessage)
            return object;
        var message = new $root.TrackChangesGetAllSuggestionMessage();
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    TrackChangesGetAllSuggestionMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.documentId = "";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    TrackChangesGetAllSuggestionMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesGetAllSuggestionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesGetAllSuggestionMessage";
    };

    return TrackChangesGetAllSuggestionMessage;
})();

$root.TrackChangesGetSuggestionMessage = (function() {

    function TrackChangesGetSuggestionMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesGetSuggestionMessage.prototype.id = "";
    TrackChangesGetSuggestionMessage.prototype.documentId = "";

    TrackChangesGetSuggestionMessage.create = function create(properties) {
        return new TrackChangesGetSuggestionMessage(properties);
    };

    TrackChangesGetSuggestionMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        return writer;
    };

    TrackChangesGetSuggestionMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesGetSuggestionMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesGetSuggestionMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesGetSuggestionMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesGetSuggestionMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        return null;
    };

    TrackChangesGetSuggestionMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesGetSuggestionMessage)
            return object;
        var message = new $root.TrackChangesGetSuggestionMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        return message;
    };

    TrackChangesGetSuggestionMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.documentId = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        return object;
    };

    TrackChangesGetSuggestionMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesGetSuggestionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesGetSuggestionMessage";
    };

    return TrackChangesGetSuggestionMessage;
})();

$root.TrackChangesUpdateSuggestionMessage = (function() {

    function TrackChangesUpdateSuggestionMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesUpdateSuggestionMessage.prototype.id = "";
    TrackChangesUpdateSuggestionMessage.prototype.documentId = "";
    TrackChangesUpdateSuggestionMessage.prototype.hasComments = false;
    TrackChangesUpdateSuggestionMessage.prototype.isHasCommentsModified = false;
    TrackChangesUpdateSuggestionMessage.prototype.state = "";
    TrackChangesUpdateSuggestionMessage.prototype.attributes = "";

    TrackChangesUpdateSuggestionMessage.create = function create(properties) {
        return new TrackChangesUpdateSuggestionMessage(properties);
    };

    TrackChangesUpdateSuggestionMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.documentId != null && Object.hasOwnProperty.call(message, "documentId"))
            writer.uint32(18).string(message.documentId);
        if (message.hasComments != null && Object.hasOwnProperty.call(message, "hasComments"))
            writer.uint32(24).bool(message.hasComments);
        if (message.isHasCommentsModified != null && Object.hasOwnProperty.call(message, "isHasCommentsModified"))
            writer.uint32(32).bool(message.isHasCommentsModified);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(42).string(message.state);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(50).string(message.attributes);
        return writer;
    };

    TrackChangesUpdateSuggestionMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesUpdateSuggestionMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesUpdateSuggestionMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.documentId = reader.string();
                    break;
                }
            case 3: {
                    message.hasComments = reader.bool();
                    break;
                }
            case 4: {
                    message.isHasCommentsModified = reader.bool();
                    break;
                }
            case 5: {
                    message.state = reader.string();
                    break;
                }
            case 6: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesUpdateSuggestionMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesUpdateSuggestionMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            if (!$util.isString(message.documentId))
                return "documentId: string expected";
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            if (typeof message.hasComments !== "boolean")
                return "hasComments: boolean expected";
        if (message.isHasCommentsModified != null && message.hasOwnProperty("isHasCommentsModified"))
            if (typeof message.isHasCommentsModified !== "boolean")
                return "isHasCommentsModified: boolean expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    TrackChangesUpdateSuggestionMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesUpdateSuggestionMessage)
            return object;
        var message = new $root.TrackChangesUpdateSuggestionMessage();
        if (object.id != null)
            message.id = String(object.id);
        if (object.documentId != null)
            message.documentId = String(object.documentId);
        if (object.hasComments != null)
            message.hasComments = Boolean(object.hasComments);
        if (object.isHasCommentsModified != null)
            message.isHasCommentsModified = Boolean(object.isHasCommentsModified);
        if (object.state != null)
            message.state = String(object.state);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    TrackChangesUpdateSuggestionMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.documentId = "";
            object.hasComments = false;
            object.isHasCommentsModified = false;
            object.state = "";
            object.attributes = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.documentId != null && message.hasOwnProperty("documentId"))
            object.documentId = message.documentId;
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            object.hasComments = message.hasComments;
        if (message.isHasCommentsModified != null && message.hasOwnProperty("isHasCommentsModified"))
            object.isHasCommentsModified = message.isHasCommentsModified;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    TrackChangesUpdateSuggestionMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesUpdateSuggestionMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesUpdateSuggestionMessage";
    };

    return TrackChangesUpdateSuggestionMessage;
})();

$root.TrackChangesAddSuggestionResponse = (function() {

    function TrackChangesAddSuggestionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesAddSuggestionResponse.prototype.id = "";
    TrackChangesAddSuggestionResponse.prototype.authorId = "";
    TrackChangesAddSuggestionResponse.prototype.type = "";
    TrackChangesAddSuggestionResponse.prototype.createdAt = "";
    TrackChangesAddSuggestionResponse.prototype.data = "";
    TrackChangesAddSuggestionResponse.prototype.hasComments = false;
    TrackChangesAddSuggestionResponse.prototype.state = "";
    TrackChangesAddSuggestionResponse.prototype.attributes = "";

    TrackChangesAddSuggestionResponse.create = function create(properties) {
        return new TrackChangesAddSuggestionResponse(properties);
    };

    TrackChangesAddSuggestionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
            writer.uint32(18).string(message.authorId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(26).string(message.type);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(34).string(message.createdAt);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).string(message.data);
        if (message.hasComments != null && Object.hasOwnProperty.call(message, "hasComments"))
            writer.uint32(48).bool(message.hasComments);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(58).string(message.state);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(66).string(message.attributes);
        return writer;
    };

    TrackChangesAddSuggestionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesAddSuggestionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesAddSuggestionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.authorId = reader.string();
                    break;
                }
            case 3: {
                    message.type = reader.string();
                    break;
                }
            case 4: {
                    message.createdAt = reader.string();
                    break;
                }
            case 5: {
                    message.data = reader.string();
                    break;
                }
            case 6: {
                    message.hasComments = reader.bool();
                    break;
                }
            case 7: {
                    message.state = reader.string();
                    break;
                }
            case 8: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesAddSuggestionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesAddSuggestionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            if (!$util.isString(message.authorId))
                return "authorId: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            if (typeof message.hasComments !== "boolean")
                return "hasComments: boolean expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    TrackChangesAddSuggestionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesAddSuggestionResponse)
            return object;
        var message = new $root.TrackChangesAddSuggestionResponse();
        if (object.id != null)
            message.id = String(object.id);
        if (object.authorId != null)
            message.authorId = String(object.authorId);
        if (object.type != null)
            message.type = String(object.type);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.data != null)
            message.data = String(object.data);
        if (object.hasComments != null)
            message.hasComments = Boolean(object.hasComments);
        if (object.state != null)
            message.state = String(object.state);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    TrackChangesAddSuggestionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.authorId = "";
            object.type = "";
            object.createdAt = "";
            object.data = "";
            object.hasComments = false;
            object.state = "";
            object.attributes = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            object.authorId = message.authorId;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            object.hasComments = message.hasComments;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    TrackChangesAddSuggestionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesAddSuggestionResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesAddSuggestionResponse";
    };

    return TrackChangesAddSuggestionResponse;
})();

$root.TrackChangesConnectResponse = (function() {

    function TrackChangesConnectResponse(properties) {
        this.suggestions = [];
        this.suggestionsV2 = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesConnectResponse.prototype.channel = "";
    TrackChangesConnectResponse.prototype.suggestions = $util.emptyArray;
    TrackChangesConnectResponse.prototype.suggestionsV2 = $util.emptyArray;

    TrackChangesConnectResponse.create = function create(properties) {
        return new TrackChangesConnectResponse(properties);
    };

    TrackChangesConnectResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
            writer.uint32(10).string(message.channel);
        if (message.suggestions != null && message.suggestions.length)
            for (var i = 0; i < message.suggestions.length; ++i)
                writer.uint32(18).string(message.suggestions[i]);
        if (message.suggestionsV2 != null && message.suggestionsV2.length)
            for (var i = 0; i < message.suggestionsV2.length; ++i)
                $root.SuggestionDescriptor.encode(message.suggestionsV2[i], writer.uint32(26).fork()).ldelim();
        return writer;
    };

    TrackChangesConnectResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesConnectResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesConnectResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.channel = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.suggestions && message.suggestions.length))
                        message.suggestions = [];
                    message.suggestions.push(reader.string());
                    break;
                }
            case 3: {
                    if (!(message.suggestionsV2 && message.suggestionsV2.length))
                        message.suggestionsV2 = [];
                    message.suggestionsV2.push($root.SuggestionDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesConnectResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesConnectResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.channel != null && message.hasOwnProperty("channel"))
            if (!$util.isString(message.channel))
                return "channel: string expected";
        if (message.suggestions != null && message.hasOwnProperty("suggestions")) {
            if (!Array.isArray(message.suggestions))
                return "suggestions: array expected";
            for (var i = 0; i < message.suggestions.length; ++i)
                if (!$util.isString(message.suggestions[i]))
                    return "suggestions: string[] expected";
        }
        if (message.suggestionsV2 != null && message.hasOwnProperty("suggestionsV2")) {
            if (!Array.isArray(message.suggestionsV2))
                return "suggestionsV2: array expected";
            for (var i = 0; i < message.suggestionsV2.length; ++i) {
                var error = $root.SuggestionDescriptor.verify(message.suggestionsV2[i]);
                if (error)
                    return "suggestionsV2." + error;
            }
        }
        return null;
    };

    TrackChangesConnectResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesConnectResponse)
            return object;
        var message = new $root.TrackChangesConnectResponse();
        if (object.channel != null)
            message.channel = String(object.channel);
        if (object.suggestions) {
            if (!Array.isArray(object.suggestions))
                throw TypeError(".TrackChangesConnectResponse.suggestions: array expected");
            message.suggestions = [];
            for (var i = 0; i < object.suggestions.length; ++i)
                message.suggestions[i] = String(object.suggestions[i]);
        }
        if (object.suggestionsV2) {
            if (!Array.isArray(object.suggestionsV2))
                throw TypeError(".TrackChangesConnectResponse.suggestionsV2: array expected");
            message.suggestionsV2 = [];
            for (var i = 0; i < object.suggestionsV2.length; ++i) {
                if (typeof object.suggestionsV2[i] !== "object")
                    throw TypeError(".TrackChangesConnectResponse.suggestionsV2: object expected");
                message.suggestionsV2[i] = $root.SuggestionDescriptor.fromObject(object.suggestionsV2[i]);
            }
        }
        return message;
    };

    TrackChangesConnectResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.suggestions = [];
            object.suggestionsV2 = [];
        }
        if (options.defaults)
            object.channel = "";
        if (message.channel != null && message.hasOwnProperty("channel"))
            object.channel = message.channel;
        if (message.suggestions && message.suggestions.length) {
            object.suggestions = [];
            for (var j = 0; j < message.suggestions.length; ++j)
                object.suggestions[j] = message.suggestions[j];
        }
        if (message.suggestionsV2 && message.suggestionsV2.length) {
            object.suggestionsV2 = [];
            for (var j = 0; j < message.suggestionsV2.length; ++j)
                object.suggestionsV2[j] = $root.SuggestionDescriptor.toObject(message.suggestionsV2[j], options);
        }
        return object;
    };

    TrackChangesConnectResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesConnectResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesConnectResponse";
    };

    return TrackChangesConnectResponse;
})();

$root.TrackChangesGetAllSuggestionsResponse = (function() {

    function TrackChangesGetAllSuggestionsResponse(properties) {
        this.suggestions = [];
        this.suggestionsV2 = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesGetAllSuggestionsResponse.prototype.suggestions = $util.emptyArray;
    TrackChangesGetAllSuggestionsResponse.prototype.suggestionsV2 = $util.emptyArray;

    TrackChangesGetAllSuggestionsResponse.create = function create(properties) {
        return new TrackChangesGetAllSuggestionsResponse(properties);
    };

    TrackChangesGetAllSuggestionsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.suggestions != null && message.suggestions.length)
            for (var i = 0; i < message.suggestions.length; ++i)
                writer.uint32(10).string(message.suggestions[i]);
        if (message.suggestionsV2 != null && message.suggestionsV2.length)
            for (var i = 0; i < message.suggestionsV2.length; ++i)
                $root.SuggestionDescriptor.encode(message.suggestionsV2[i], writer.uint32(18).fork()).ldelim();
        return writer;
    };

    TrackChangesGetAllSuggestionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesGetAllSuggestionsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesGetAllSuggestionsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.suggestions && message.suggestions.length))
                        message.suggestions = [];
                    message.suggestions.push(reader.string());
                    break;
                }
            case 2: {
                    if (!(message.suggestionsV2 && message.suggestionsV2.length))
                        message.suggestionsV2 = [];
                    message.suggestionsV2.push($root.SuggestionDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesGetAllSuggestionsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesGetAllSuggestionsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.suggestions != null && message.hasOwnProperty("suggestions")) {
            if (!Array.isArray(message.suggestions))
                return "suggestions: array expected";
            for (var i = 0; i < message.suggestions.length; ++i)
                if (!$util.isString(message.suggestions[i]))
                    return "suggestions: string[] expected";
        }
        if (message.suggestionsV2 != null && message.hasOwnProperty("suggestionsV2")) {
            if (!Array.isArray(message.suggestionsV2))
                return "suggestionsV2: array expected";
            for (var i = 0; i < message.suggestionsV2.length; ++i) {
                var error = $root.SuggestionDescriptor.verify(message.suggestionsV2[i]);
                if (error)
                    return "suggestionsV2." + error;
            }
        }
        return null;
    };

    TrackChangesGetAllSuggestionsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesGetAllSuggestionsResponse)
            return object;
        var message = new $root.TrackChangesGetAllSuggestionsResponse();
        if (object.suggestions) {
            if (!Array.isArray(object.suggestions))
                throw TypeError(".TrackChangesGetAllSuggestionsResponse.suggestions: array expected");
            message.suggestions = [];
            for (var i = 0; i < object.suggestions.length; ++i)
                message.suggestions[i] = String(object.suggestions[i]);
        }
        if (object.suggestionsV2) {
            if (!Array.isArray(object.suggestionsV2))
                throw TypeError(".TrackChangesGetAllSuggestionsResponse.suggestionsV2: array expected");
            message.suggestionsV2 = [];
            for (var i = 0; i < object.suggestionsV2.length; ++i) {
                if (typeof object.suggestionsV2[i] !== "object")
                    throw TypeError(".TrackChangesGetAllSuggestionsResponse.suggestionsV2: object expected");
                message.suggestionsV2[i] = $root.SuggestionDescriptor.fromObject(object.suggestionsV2[i]);
            }
        }
        return message;
    };

    TrackChangesGetAllSuggestionsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.suggestions = [];
            object.suggestionsV2 = [];
        }
        if (message.suggestions && message.suggestions.length) {
            object.suggestions = [];
            for (var j = 0; j < message.suggestions.length; ++j)
                object.suggestions[j] = message.suggestions[j];
        }
        if (message.suggestionsV2 && message.suggestionsV2.length) {
            object.suggestionsV2 = [];
            for (var j = 0; j < message.suggestionsV2.length; ++j)
                object.suggestionsV2[j] = $root.SuggestionDescriptor.toObject(message.suggestionsV2[j], options);
        }
        return object;
    };

    TrackChangesGetAllSuggestionsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesGetAllSuggestionsResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesGetAllSuggestionsResponse";
    };

    return TrackChangesGetAllSuggestionsResponse;
})();

$root.TrackChangesGetSuggestionResponse = (function() {

    function TrackChangesGetSuggestionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    TrackChangesGetSuggestionResponse.prototype.id = "";
    TrackChangesGetSuggestionResponse.prototype.authorId = "";
    TrackChangesGetSuggestionResponse.prototype.type = "";
    TrackChangesGetSuggestionResponse.prototype.createdAt = "";
    TrackChangesGetSuggestionResponse.prototype.data = "";
    TrackChangesGetSuggestionResponse.prototype.hasComments = false;
    TrackChangesGetSuggestionResponse.prototype.state = "";
    TrackChangesGetSuggestionResponse.prototype.attributes = "";

    TrackChangesGetSuggestionResponse.create = function create(properties) {
        return new TrackChangesGetSuggestionResponse(properties);
    };

    TrackChangesGetSuggestionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        if (message.authorId != null && Object.hasOwnProperty.call(message, "authorId"))
            writer.uint32(18).string(message.authorId);
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(26).string(message.type);
        if (message.createdAt != null && Object.hasOwnProperty.call(message, "createdAt"))
            writer.uint32(34).string(message.createdAt);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(42).string(message.data);
        if (message.hasComments != null && Object.hasOwnProperty.call(message, "hasComments"))
            writer.uint32(48).bool(message.hasComments);
        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
            writer.uint32(58).string(message.state);
        if (message.attributes != null && Object.hasOwnProperty.call(message, "attributes"))
            writer.uint32(66).string(message.attributes);
        return writer;
    };

    TrackChangesGetSuggestionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    TrackChangesGetSuggestionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TrackChangesGetSuggestionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            case 2: {
                    message.authorId = reader.string();
                    break;
                }
            case 3: {
                    message.type = reader.string();
                    break;
                }
            case 4: {
                    message.createdAt = reader.string();
                    break;
                }
            case 5: {
                    message.data = reader.string();
                    break;
                }
            case 6: {
                    message.hasComments = reader.bool();
                    break;
                }
            case 7: {
                    message.state = reader.string();
                    break;
                }
            case 8: {
                    message.attributes = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    TrackChangesGetSuggestionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    TrackChangesGetSuggestionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            if (!$util.isString(message.authorId))
                return "authorId: string expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isString(message.type))
                return "type: string expected";
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            if (!$util.isString(message.createdAt))
                return "createdAt: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            if (typeof message.hasComments !== "boolean")
                return "hasComments: boolean expected";
        if (message.state != null && message.hasOwnProperty("state"))
            if (!$util.isString(message.state))
                return "state: string expected";
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            if (!$util.isString(message.attributes))
                return "attributes: string expected";
        return null;
    };

    TrackChangesGetSuggestionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TrackChangesGetSuggestionResponse)
            return object;
        var message = new $root.TrackChangesGetSuggestionResponse();
        if (object.id != null)
            message.id = String(object.id);
        if (object.authorId != null)
            message.authorId = String(object.authorId);
        if (object.type != null)
            message.type = String(object.type);
        if (object.createdAt != null)
            message.createdAt = String(object.createdAt);
        if (object.data != null)
            message.data = String(object.data);
        if (object.hasComments != null)
            message.hasComments = Boolean(object.hasComments);
        if (object.state != null)
            message.state = String(object.state);
        if (object.attributes != null)
            message.attributes = String(object.attributes);
        return message;
    };

    TrackChangesGetSuggestionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.id = "";
            object.authorId = "";
            object.type = "";
            object.createdAt = "";
            object.data = "";
            object.hasComments = false;
            object.state = "";
            object.attributes = "";
        }
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.authorId != null && message.hasOwnProperty("authorId"))
            object.authorId = message.authorId;
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.createdAt != null && message.hasOwnProperty("createdAt"))
            object.createdAt = message.createdAt;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.hasComments != null && message.hasOwnProperty("hasComments"))
            object.hasComments = message.hasComments;
        if (message.state != null && message.hasOwnProperty("state"))
            object.state = message.state;
        if (message.attributes != null && message.hasOwnProperty("attributes"))
            object.attributes = message.attributes;
        return object;
    };

    TrackChangesGetSuggestionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    TrackChangesGetSuggestionResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/TrackChangesGetSuggestionResponse";
    };

    return TrackChangesGetSuggestionResponse;
})();

$root.UserDescriptor = (function() {

    function UserDescriptor(properties) {
        this.attributes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    UserDescriptor.prototype.attributes = $util.emptyArray;

    UserDescriptor.create = function create(properties) {
        return new UserDescriptor(properties);
    };

    UserDescriptor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.attributes != null && message.attributes.length)
            for (var i = 0; i < message.attributes.length; ++i)
                $root.KeyValueDescriptor.encode(message.attributes[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    UserDescriptor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    UserDescriptor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.UserDescriptor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.attributes && message.attributes.length))
                        message.attributes = [];
                    message.attributes.push($root.KeyValueDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    UserDescriptor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    UserDescriptor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.attributes != null && message.hasOwnProperty("attributes")) {
            if (!Array.isArray(message.attributes))
                return "attributes: array expected";
            for (var i = 0; i < message.attributes.length; ++i) {
                var error = $root.KeyValueDescriptor.verify(message.attributes[i]);
                if (error)
                    return "attributes." + error;
            }
        }
        return null;
    };

    UserDescriptor.fromObject = function fromObject(object) {
        if (object instanceof $root.UserDescriptor)
            return object;
        var message = new $root.UserDescriptor();
        if (object.attributes) {
            if (!Array.isArray(object.attributes))
                throw TypeError(".UserDescriptor.attributes: array expected");
            message.attributes = [];
            for (var i = 0; i < object.attributes.length; ++i) {
                if (typeof object.attributes[i] !== "object")
                    throw TypeError(".UserDescriptor.attributes: object expected");
                message.attributes[i] = $root.KeyValueDescriptor.fromObject(object.attributes[i]);
            }
        }
        return message;
    };

    UserDescriptor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.attributes = [];
        if (message.attributes && message.attributes.length) {
            object.attributes = [];
            for (var j = 0; j < message.attributes.length; ++j)
                object.attributes[j] = $root.KeyValueDescriptor.toObject(message.attributes[j], options);
        }
        return object;
    };

    UserDescriptor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    UserDescriptor.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/UserDescriptor";
    };

    return UserDescriptor;
})();

$root.GetManyUsersMessage = (function() {

    function GetManyUsersMessage(properties) {
        this.ids = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetManyUsersMessage.prototype.ids = $util.emptyArray;

    GetManyUsersMessage.create = function create(properties) {
        return new GetManyUsersMessage(properties);
    };

    GetManyUsersMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ids != null && message.ids.length)
            for (var i = 0; i < message.ids.length; ++i)
                writer.uint32(10).string(message.ids[i]);
        return writer;
    };

    GetManyUsersMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetManyUsersMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetManyUsersMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.ids && message.ids.length))
                        message.ids = [];
                    message.ids.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetManyUsersMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetManyUsersMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ids != null && message.hasOwnProperty("ids")) {
            if (!Array.isArray(message.ids))
                return "ids: array expected";
            for (var i = 0; i < message.ids.length; ++i)
                if (!$util.isString(message.ids[i]))
                    return "ids: string[] expected";
        }
        return null;
    };

    GetManyUsersMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.GetManyUsersMessage)
            return object;
        var message = new $root.GetManyUsersMessage();
        if (object.ids) {
            if (!Array.isArray(object.ids))
                throw TypeError(".GetManyUsersMessage.ids: array expected");
            message.ids = [];
            for (var i = 0; i < object.ids.length; ++i)
                message.ids[i] = String(object.ids[i]);
        }
        return message;
    };

    GetManyUsersMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.ids = [];
        if (message.ids && message.ids.length) {
            object.ids = [];
            for (var j = 0; j < message.ids.length; ++j)
                object.ids[j] = message.ids[j];
        }
        return object;
    };

    GetManyUsersMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetManyUsersMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetManyUsersMessage";
    };

    return GetManyUsersMessage;
})();

$root.GetUserMessage = (function() {

    function GetUserMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetUserMessage.prototype.id = "";

    GetUserMessage.create = function create(properties) {
        return new GetUserMessage(properties);
    };

    GetUserMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(10).string(message.id);
        return writer;
    };

    GetUserMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetUserMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetUserMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.id = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetUserMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetUserMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isString(message.id))
                return "id: string expected";
        return null;
    };

    GetUserMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.GetUserMessage)
            return object;
        var message = new $root.GetUserMessage();
        if (object.id != null)
            message.id = String(object.id);
        return message;
    };

    GetUserMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.id = "";
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        return object;
    };

    GetUserMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetUserMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetUserMessage";
    };

    return GetUserMessage;
})();

$root.GetManyUsersResponse = (function() {

    function GetManyUsersResponse(properties) {
        this.users = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetManyUsersResponse.prototype.users = $util.emptyArray;

    GetManyUsersResponse.create = function create(properties) {
        return new GetManyUsersResponse(properties);
    };

    GetManyUsersResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.users != null && message.users.length)
            for (var i = 0; i < message.users.length; ++i)
                $root.UserDescriptor.encode(message.users[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    GetManyUsersResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetManyUsersResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetManyUsersResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.users && message.users.length))
                        message.users = [];
                    message.users.push($root.UserDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetManyUsersResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetManyUsersResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.users != null && message.hasOwnProperty("users")) {
            if (!Array.isArray(message.users))
                return "users: array expected";
            for (var i = 0; i < message.users.length; ++i) {
                var error = $root.UserDescriptor.verify(message.users[i]);
                if (error)
                    return "users." + error;
            }
        }
        return null;
    };

    GetManyUsersResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetManyUsersResponse)
            return object;
        var message = new $root.GetManyUsersResponse();
        if (object.users) {
            if (!Array.isArray(object.users))
                throw TypeError(".GetManyUsersResponse.users: array expected");
            message.users = [];
            for (var i = 0; i < object.users.length; ++i) {
                if (typeof object.users[i] !== "object")
                    throw TypeError(".GetManyUsersResponse.users: object expected");
                message.users[i] = $root.UserDescriptor.fromObject(object.users[i]);
            }
        }
        return message;
    };

    GetManyUsersResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.users = [];
        if (message.users && message.users.length) {
            object.users = [];
            for (var j = 0; j < message.users.length; ++j)
                object.users[j] = $root.UserDescriptor.toObject(message.users[j], options);
        }
        return object;
    };

    GetManyUsersResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetManyUsersResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetManyUsersResponse";
    };

    return GetManyUsersResponse;
})();

$root.GetUserResponse = (function() {

    function GetUserResponse(properties) {
        this.attributes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    GetUserResponse.prototype.attributes = $util.emptyArray;

    GetUserResponse.create = function create(properties) {
        return new GetUserResponse(properties);
    };

    GetUserResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.attributes != null && message.attributes.length)
            for (var i = 0; i < message.attributes.length; ++i)
                $root.KeyValueDescriptor.encode(message.attributes[i], writer.uint32(10).fork()).ldelim();
        return writer;
    };

    GetUserResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    GetUserResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetUserResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    if (!(message.attributes && message.attributes.length))
                        message.attributes = [];
                    message.attributes.push($root.KeyValueDescriptor.decode(reader, reader.uint32()));
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    GetUserResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    GetUserResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.attributes != null && message.hasOwnProperty("attributes")) {
            if (!Array.isArray(message.attributes))
                return "attributes: array expected";
            for (var i = 0; i < message.attributes.length; ++i) {
                var error = $root.KeyValueDescriptor.verify(message.attributes[i]);
                if (error)
                    return "attributes." + error;
            }
        }
        return null;
    };

    GetUserResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetUserResponse)
            return object;
        var message = new $root.GetUserResponse();
        if (object.attributes) {
            if (!Array.isArray(object.attributes))
                throw TypeError(".GetUserResponse.attributes: array expected");
            message.attributes = [];
            for (var i = 0; i < object.attributes.length; ++i) {
                if (typeof object.attributes[i] !== "object")
                    throw TypeError(".GetUserResponse.attributes: object expected");
                message.attributes[i] = $root.KeyValueDescriptor.fromObject(object.attributes[i]);
            }
        }
        return message;
    };

    GetUserResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.attributes = [];
        if (message.attributes && message.attributes.length) {
            object.attributes = [];
            for (var j = 0; j < message.attributes.length; ++j)
                object.attributes[j] = $root.KeyValueDescriptor.toObject(message.attributes[j], options);
        }
        return object;
    };

    GetUserResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    GetUserResponse.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/GetUserResponse";
    };

    return GetUserResponse;
})();

$root.ChannelMessage = (function() {

    function ChannelMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ChannelMessage.prototype.type = 0;
    ChannelMessage.prototype.socketId = "";
    ChannelMessage.prototype.data = $util.newBuffer([]);

    ChannelMessage.create = function create(properties) {
        return new ChannelMessage(properties);
    };

    ChannelMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).uint32(message.type);
        if (message.socketId != null && Object.hasOwnProperty.call(message, "socketId"))
            writer.uint32(18).string(message.socketId);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(26).bytes(message.data);
        return writer;
    };

    ChannelMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ChannelMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ChannelMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.uint32();
                    break;
                }
            case 2: {
                    message.socketId = reader.string();
                    break;
                }
            case 3: {
                    message.data = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ChannelMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ChannelMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isInteger(message.type))
                return "type: integer expected";
        if (message.socketId != null && message.hasOwnProperty("socketId"))
            if (!$util.isString(message.socketId))
                return "socketId: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        return null;
    };

    ChannelMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ChannelMessage)
            return object;
        var message = new $root.ChannelMessage();
        if (object.type != null)
            message.type = object.type >>> 0;
        if (object.socketId != null)
            message.socketId = String(object.socketId);
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length >= 0)
                message.data = object.data;
        return message;
    };

    ChannelMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = 0;
            object.socketId = "";
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.socketId != null && message.hasOwnProperty("socketId"))
            object.socketId = message.socketId;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        return object;
    };

    ChannelMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ChannelMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ChannelMessage";
    };

    return ChannelMessage;
})();

$root.BytesBytesPacketDataMessage = (function() {

    function BytesBytesPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    BytesBytesPacketDataMessage.prototype.data = $util.newBuffer([]);
    BytesBytesPacketDataMessage.prototype.data1 = $util.newBuffer([]);

    BytesBytesPacketDataMessage.create = function create(properties) {
        return new BytesBytesPacketDataMessage(properties);
    };

    BytesBytesPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).bytes(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).bytes(message.data1);
        return writer;
    };

    BytesBytesPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    BytesBytesPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BytesBytesPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.bytes();
                    break;
                }
            case 2: {
                    message.data1 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    BytesBytesPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    BytesBytesPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        return null;
    };

    BytesBytesPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.BytesBytesPacketDataMessage)
            return object;
        var message = new $root.BytesBytesPacketDataMessage();
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length >= 0)
                message.data = object.data;
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length >= 0)
                message.data1 = object.data1;
        return message;
    };

    BytesBytesPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        return object;
    };

    BytesBytesPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    BytesBytesPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/BytesBytesPacketDataMessage";
    };

    return BytesBytesPacketDataMessage;
})();

$root.NumberBytesPacketDataMessage = (function() {

    function NumberBytesPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NumberBytesPacketDataMessage.prototype.data = 0;
    NumberBytesPacketDataMessage.prototype.data1 = $util.newBuffer([]);

    NumberBytesPacketDataMessage.create = function create(properties) {
        return new NumberBytesPacketDataMessage(properties);
    };

    NumberBytesPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(8).uint32(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).bytes(message.data1);
        return writer;
    };

    NumberBytesPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NumberBytesPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NumberBytesPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.uint32();
                    break;
                }
            case 2: {
                    message.data1 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NumberBytesPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NumberBytesPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isInteger(message.data))
                return "data: integer expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        return null;
    };

    NumberBytesPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NumberBytesPacketDataMessage)
            return object;
        var message = new $root.NumberBytesPacketDataMessage();
        if (object.data != null)
            message.data = object.data >>> 0;
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length >= 0)
                message.data1 = object.data1;
        return message;
    };

    NumberBytesPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = 0;
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        return object;
    };

    NumberBytesPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NumberBytesPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/NumberBytesPacketDataMessage";
    };

    return NumberBytesPacketDataMessage;
})();

$root.NumberNumberPacketDataMessage = (function() {

    function NumberNumberPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NumberNumberPacketDataMessage.prototype.data = 0;
    NumberNumberPacketDataMessage.prototype.data1 = 0;

    NumberNumberPacketDataMessage.create = function create(properties) {
        return new NumberNumberPacketDataMessage(properties);
    };

    NumberNumberPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(8).uint32(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(16).uint32(message.data1);
        return writer;
    };

    NumberNumberPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NumberNumberPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NumberNumberPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.uint32();
                    break;
                }
            case 2: {
                    message.data1 = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NumberNumberPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NumberNumberPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isInteger(message.data))
                return "data: integer expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isInteger(message.data1))
                return "data1: integer expected";
        return null;
    };

    NumberNumberPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NumberNumberPacketDataMessage)
            return object;
        var message = new $root.NumberNumberPacketDataMessage();
        if (object.data != null)
            message.data = object.data >>> 0;
        if (object.data1 != null)
            message.data1 = object.data1 >>> 0;
        return message;
    };

    NumberNumberPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = 0;
            object.data1 = 0;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    NumberNumberPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NumberNumberPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/NumberNumberPacketDataMessage";
    };

    return NumberNumberPacketDataMessage;
})();

$root.NumberObjectPacketDataMessage = (function() {

    function NumberObjectPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NumberObjectPacketDataMessage.prototype.data = 0;
    NumberObjectPacketDataMessage.prototype.data1 = "";

    NumberObjectPacketDataMessage.create = function create(properties) {
        return new NumberObjectPacketDataMessage(properties);
    };

    NumberObjectPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(8).uint32(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).string(message.data1);
        return writer;
    };

    NumberObjectPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NumberObjectPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NumberObjectPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.uint32();
                    break;
                }
            case 2: {
                    message.data1 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NumberObjectPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NumberObjectPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isInteger(message.data))
                return "data: integer expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isString(message.data1))
                return "data1: string expected";
        return null;
    };

    NumberObjectPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NumberObjectPacketDataMessage)
            return object;
        var message = new $root.NumberObjectPacketDataMessage();
        if (object.data != null)
            message.data = object.data >>> 0;
        if (object.data1 != null)
            message.data1 = String(object.data1);
        return message;
    };

    NumberObjectPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = 0;
            object.data1 = "";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    NumberObjectPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NumberObjectPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/NumberObjectPacketDataMessage";
    };

    return NumberObjectPacketDataMessage;
})();

$root.NumberStringPacketDataMessage = (function() {

    function NumberStringPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    NumberStringPacketDataMessage.prototype.data = 0;
    NumberStringPacketDataMessage.prototype.data1 = "";

    NumberStringPacketDataMessage.create = function create(properties) {
        return new NumberStringPacketDataMessage(properties);
    };

    NumberStringPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(8).uint32(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).string(message.data1);
        return writer;
    };

    NumberStringPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    NumberStringPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NumberStringPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.uint32();
                    break;
                }
            case 2: {
                    message.data1 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    NumberStringPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    NumberStringPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isInteger(message.data))
                return "data: integer expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isString(message.data1))
                return "data1: string expected";
        return null;
    };

    NumberStringPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.NumberStringPacketDataMessage)
            return object;
        var message = new $root.NumberStringPacketDataMessage();
        if (object.data != null)
            message.data = object.data >>> 0;
        if (object.data1 != null)
            message.data1 = String(object.data1);
        return message;
    };

    NumberStringPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = 0;
            object.data1 = "";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    NumberStringPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    NumberStringPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/NumberStringPacketDataMessage";
    };

    return NumberStringPacketDataMessage;
})();

$root.ObjectBufferPacketDataMessage = (function() {

    function ObjectBufferPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ObjectBufferPacketDataMessage.prototype.data = "";
    ObjectBufferPacketDataMessage.prototype.data1 = $util.newBuffer([]);

    ObjectBufferPacketDataMessage.create = function create(properties) {
        return new ObjectBufferPacketDataMessage(properties);
    };

    ObjectBufferPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).bytes(message.data1);
        return writer;
    };

    ObjectBufferPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ObjectBufferPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ObjectBufferPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ObjectBufferPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ObjectBufferPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        return null;
    };

    ObjectBufferPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ObjectBufferPacketDataMessage)
            return object;
        var message = new $root.ObjectBufferPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length >= 0)
                message.data1 = object.data1;
        return message;
    };

    ObjectBufferPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        return object;
    };

    ObjectBufferPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ObjectBufferPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ObjectBufferPacketDataMessage";
    };

    return ObjectBufferPacketDataMessage;
})();

$root.ObjectObjectPacketDataMessage = (function() {

    function ObjectObjectPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    ObjectObjectPacketDataMessage.prototype.data = "";
    ObjectObjectPacketDataMessage.prototype.data1 = "";

    ObjectObjectPacketDataMessage.create = function create(properties) {
        return new ObjectObjectPacketDataMessage(properties);
    };

    ObjectObjectPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).string(message.data1);
        return writer;
    };

    ObjectObjectPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    ObjectObjectPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ObjectObjectPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    ObjectObjectPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    ObjectObjectPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isString(message.data1))
                return "data1: string expected";
        return null;
    };

    ObjectObjectPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.ObjectObjectPacketDataMessage)
            return object;
        var message = new $root.ObjectObjectPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            message.data1 = String(object.data1);
        return message;
    };

    ObjectObjectPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            object.data1 = "";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    ObjectObjectPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    ObjectObjectPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/ObjectObjectPacketDataMessage";
    };

    return ObjectObjectPacketDataMessage;
})();

$root.PacketMessage = (function() {

    function PacketMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PacketMessage.prototype.type = 0;
    PacketMessage.prototype.id = 0;
    PacketMessage.prototype.nsp = "";
    PacketMessage.prototype.data = $util.newBuffer([]);
    PacketMessage.prototype.options = $util.newBuffer([]);

    PacketMessage.create = function create(properties) {
        return new PacketMessage(properties);
    };

    PacketMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
            writer.uint32(8).uint32(message.type);
        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
            writer.uint32(16).uint32(message.id);
        if (message.nsp != null && Object.hasOwnProperty.call(message, "nsp"))
            writer.uint32(26).string(message.nsp);
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(34).bytes(message.data);
        if (message.options != null && Object.hasOwnProperty.call(message, "options"))
            writer.uint32(42).bytes(message.options);
        return writer;
    };

    PacketMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PacketMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PacketMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.type = reader.uint32();
                    break;
                }
            case 2: {
                    message.id = reader.uint32();
                    break;
                }
            case 3: {
                    message.nsp = reader.string();
                    break;
                }
            case 4: {
                    message.data = reader.bytes();
                    break;
                }
            case 5: {
                    message.options = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PacketMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PacketMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.type != null && message.hasOwnProperty("type"))
            if (!$util.isInteger(message.type))
                return "type: integer expected";
        if (message.id != null && message.hasOwnProperty("id"))
            if (!$util.isInteger(message.id))
                return "id: integer expected";
        if (message.nsp != null && message.hasOwnProperty("nsp"))
            if (!$util.isString(message.nsp))
                return "nsp: string expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                return "data: buffer expected";
        if (message.options != null && message.hasOwnProperty("options"))
            if (!(message.options && typeof message.options.length === "number" || $util.isString(message.options)))
                return "options: buffer expected";
        return null;
    };

    PacketMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.PacketMessage)
            return object;
        var message = new $root.PacketMessage();
        if (object.type != null)
            message.type = object.type >>> 0;
        if (object.id != null)
            message.id = object.id >>> 0;
        if (object.nsp != null)
            message.nsp = String(object.nsp);
        if (object.data != null)
            if (typeof object.data === "string")
                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
            else if (object.data.length >= 0)
                message.data = object.data;
        if (object.options != null)
            if (typeof object.options === "string")
                $util.base64.decode(object.options, message.options = $util.newBuffer($util.base64.length(object.options)), 0);
            else if (object.options.length >= 0)
                message.options = object.options;
        return message;
    };

    PacketMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.type = 0;
            object.id = 0;
            object.nsp = "";
            if (options.bytes === String)
                object.data = "";
            else {
                object.data = [];
                if (options.bytes !== Array)
                    object.data = $util.newBuffer(object.data);
            }
            if (options.bytes === String)
                object.options = "";
            else {
                object.options = [];
                if (options.bytes !== Array)
                    object.options = $util.newBuffer(object.options);
            }
        }
        if (message.type != null && message.hasOwnProperty("type"))
            object.type = message.type;
        if (message.id != null && message.hasOwnProperty("id"))
            object.id = message.id;
        if (message.nsp != null && message.hasOwnProperty("nsp"))
            object.nsp = message.nsp;
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
        if (message.options != null && message.hasOwnProperty("options"))
            object.options = options.bytes === String ? $util.base64.encode(message.options, 0, message.options.length) : options.bytes === Array ? Array.prototype.slice.call(message.options) : message.options;
        return object;
    };

    PacketMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PacketMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PacketMessage";
    };

    return PacketMessage;
})();

$root.PacketOptionsMessage = (function() {

    function PacketOptionsMessage(properties) {
        this.rooms = [];
        this.except = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    PacketOptionsMessage.prototype.flags = "";
    PacketOptionsMessage.prototype.rooms = $util.emptyArray;
    PacketOptionsMessage.prototype.except = $util.emptyArray;

    PacketOptionsMessage.create = function create(properties) {
        return new PacketOptionsMessage(properties);
    };

    PacketOptionsMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.flags != null && Object.hasOwnProperty.call(message, "flags"))
            writer.uint32(10).string(message.flags);
        if (message.rooms != null && message.rooms.length)
            for (var i = 0; i < message.rooms.length; ++i)
                writer.uint32(18).string(message.rooms[i]);
        if (message.except != null && message.except.length)
            for (var i = 0; i < message.except.length; ++i)
                writer.uint32(26).string(message.except[i]);
        return writer;
    };

    PacketOptionsMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    PacketOptionsMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PacketOptionsMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.flags = reader.string();
                    break;
                }
            case 2: {
                    if (!(message.rooms && message.rooms.length))
                        message.rooms = [];
                    message.rooms.push(reader.string());
                    break;
                }
            case 3: {
                    if (!(message.except && message.except.length))
                        message.except = [];
                    message.except.push(reader.string());
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    PacketOptionsMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    PacketOptionsMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.flags != null && message.hasOwnProperty("flags"))
            if (!$util.isString(message.flags))
                return "flags: string expected";
        if (message.rooms != null && message.hasOwnProperty("rooms")) {
            if (!Array.isArray(message.rooms))
                return "rooms: array expected";
            for (var i = 0; i < message.rooms.length; ++i)
                if (!$util.isString(message.rooms[i]))
                    return "rooms: string[] expected";
        }
        if (message.except != null && message.hasOwnProperty("except")) {
            if (!Array.isArray(message.except))
                return "except: array expected";
            for (var i = 0; i < message.except.length; ++i)
                if (!$util.isString(message.except[i]))
                    return "except: string[] expected";
        }
        return null;
    };

    PacketOptionsMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.PacketOptionsMessage)
            return object;
        var message = new $root.PacketOptionsMessage();
        if (object.flags != null)
            message.flags = String(object.flags);
        if (object.rooms) {
            if (!Array.isArray(object.rooms))
                throw TypeError(".PacketOptionsMessage.rooms: array expected");
            message.rooms = [];
            for (var i = 0; i < object.rooms.length; ++i)
                message.rooms[i] = String(object.rooms[i]);
        }
        if (object.except) {
            if (!Array.isArray(object.except))
                throw TypeError(".PacketOptionsMessage.except: array expected");
            message.except = [];
            for (var i = 0; i < object.except.length; ++i)
                message.except[i] = String(object.except[i]);
        }
        return message;
    };

    PacketOptionsMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.rooms = [];
            object.except = [];
        }
        if (options.defaults)
            object.flags = "";
        if (message.flags != null && message.hasOwnProperty("flags"))
            object.flags = message.flags;
        if (message.rooms && message.rooms.length) {
            object.rooms = [];
            for (var j = 0; j < message.rooms.length; ++j)
                object.rooms[j] = message.rooms[j];
        }
        if (message.except && message.except.length) {
            object.except = [];
            for (var j = 0; j < message.except.length; ++j)
                object.except[j] = message.except[j];
        }
        return object;
    };

    PacketOptionsMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    PacketOptionsMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/PacketOptionsMessage";
    };

    return PacketOptionsMessage;
})();

$root.StringBytesPacketDataMessage = (function() {

    function StringBytesPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StringBytesPacketDataMessage.prototype.data = "";
    StringBytesPacketDataMessage.prototype.data1 = $util.newBuffer([]);

    StringBytesPacketDataMessage.create = function create(properties) {
        return new StringBytesPacketDataMessage(properties);
    };

    StringBytesPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).bytes(message.data1);
        return writer;
    };

    StringBytesPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StringBytesPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StringBytesPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.bytes();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StringBytesPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StringBytesPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!(message.data1 && typeof message.data1.length === "number" || $util.isString(message.data1)))
                return "data1: buffer expected";
        return null;
    };

    StringBytesPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StringBytesPacketDataMessage)
            return object;
        var message = new $root.StringBytesPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            if (typeof object.data1 === "string")
                $util.base64.decode(object.data1, message.data1 = $util.newBuffer($util.base64.length(object.data1)), 0);
            else if (object.data1.length >= 0)
                message.data1 = object.data1;
        return message;
    };

    StringBytesPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            if (options.bytes === String)
                object.data1 = "";
            else {
                object.data1 = [];
                if (options.bytes !== Array)
                    object.data1 = $util.newBuffer(object.data1);
            }
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = options.bytes === String ? $util.base64.encode(message.data1, 0, message.data1.length) : options.bytes === Array ? Array.prototype.slice.call(message.data1) : message.data1;
        return object;
    };

    StringBytesPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StringBytesPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StringBytesPacketDataMessage";
    };

    return StringBytesPacketDataMessage;
})();

$root.StringNumberPacketDataMessage = (function() {

    function StringNumberPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StringNumberPacketDataMessage.prototype.data = "";
    StringNumberPacketDataMessage.prototype.data1 = 0;

    StringNumberPacketDataMessage.create = function create(properties) {
        return new StringNumberPacketDataMessage(properties);
    };

    StringNumberPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(16).uint32(message.data1);
        return writer;
    };

    StringNumberPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StringNumberPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StringNumberPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.uint32();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StringNumberPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StringNumberPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isInteger(message.data1))
                return "data1: integer expected";
        return null;
    };

    StringNumberPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StringNumberPacketDataMessage)
            return object;
        var message = new $root.StringNumberPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            message.data1 = object.data1 >>> 0;
        return message;
    };

    StringNumberPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            object.data1 = 0;
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    StringNumberPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StringNumberPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StringNumberPacketDataMessage";
    };

    return StringNumberPacketDataMessage;
})();

$root.StringObjectPacketDataMessage = (function() {

    function StringObjectPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StringObjectPacketDataMessage.prototype.data = "";
    StringObjectPacketDataMessage.prototype.data1 = "";

    StringObjectPacketDataMessage.create = function create(properties) {
        return new StringObjectPacketDataMessage(properties);
    };

    StringObjectPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).string(message.data1);
        return writer;
    };

    StringObjectPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StringObjectPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StringObjectPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StringObjectPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StringObjectPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isString(message.data1))
                return "data1: string expected";
        return null;
    };

    StringObjectPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StringObjectPacketDataMessage)
            return object;
        var message = new $root.StringObjectPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            message.data1 = String(object.data1);
        return message;
    };

    StringObjectPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            object.data1 = "";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    StringObjectPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StringObjectPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StringObjectPacketDataMessage";
    };

    return StringObjectPacketDataMessage;
})();

$root.StringStringPacketDataMessage = (function() {

    function StringStringPacketDataMessage(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    StringStringPacketDataMessage.prototype.data = "";
    StringStringPacketDataMessage.prototype.data1 = "";

    StringStringPacketDataMessage.create = function create(properties) {
        return new StringStringPacketDataMessage(properties);
    };

    StringStringPacketDataMessage.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
            writer.uint32(10).string(message.data);
        if (message.data1 != null && Object.hasOwnProperty.call(message, "data1"))
            writer.uint32(18).string(message.data1);
        return writer;
    };

    StringStringPacketDataMessage.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    StringStringPacketDataMessage.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.StringStringPacketDataMessage();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1: {
                    message.data = reader.string();
                    break;
                }
            case 2: {
                    message.data1 = reader.string();
                    break;
                }
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    StringStringPacketDataMessage.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    StringStringPacketDataMessage.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.data != null && message.hasOwnProperty("data"))
            if (!$util.isString(message.data))
                return "data: string expected";
        if (message.data1 != null && message.hasOwnProperty("data1"))
            if (!$util.isString(message.data1))
                return "data1: string expected";
        return null;
    };

    StringStringPacketDataMessage.fromObject = function fromObject(object) {
        if (object instanceof $root.StringStringPacketDataMessage)
            return object;
        var message = new $root.StringStringPacketDataMessage();
        if (object.data != null)
            message.data = String(object.data);
        if (object.data1 != null)
            message.data1 = String(object.data1);
        return message;
    };

    StringStringPacketDataMessage.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.data = "";
            object.data1 = "";
        }
        if (message.data != null && message.hasOwnProperty("data"))
            object.data = message.data;
        if (message.data1 != null && message.hasOwnProperty("data1"))
            object.data1 = message.data1;
        return object;
    };

    StringStringPacketDataMessage.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    StringStringPacketDataMessage.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
        if (typeUrlPrefix === undefined) {
            typeUrlPrefix = "type.googleapis.com";
        }
        return typeUrlPrefix + "/StringStringPacketDataMessage";
    };

    return StringStringPacketDataMessage;
})();

	return $root;
} )();

export default messages;
